﻿/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.5.0.0 (NJsonSchema v10.1.15.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    postPostcode(files: FileParameter[] | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Uploadpostcodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostPostcode(_response);
        });
    }

    protected processPostPostcode(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    uploadStockPost(files: FileParameter[] | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/UploadStockPost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadStockPost(_response);
        });
    }

    protected processUploadStockPost(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    uploadProductsPost(files: FileParameter[] | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/UploadProductsPost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadProductsPost(_response);
        });
    }

    protected processUploadProductsPost(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    post(files: FileParameter[] | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class ReactClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    index(anything: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/v2/{anything}";
        if (anything === undefined || anything === null)
            throw new Error("The parameter 'anything' must be defined.");
        url_ = url_.replace("{anything}", encodeURIComponent("" + anything));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class AdminBookingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    addBooking(bookingDTO: AdminBookingDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/AdminBooking/addbooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBooking(_response);
        });
    }

    protected processAddBooking(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    editBooking(id: string, bookingDTO: AdminBookingDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/AdminBooking/editbooking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditBooking(_response);
        });
    }

    protected processEditBooking(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    listBooking(id: string): Promise<AdminBookingDTO> {
        let url_ = this.baseUrl + "/api/admin/AdminBooking/bookings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListBooking(_response);
        });
    }

    protected processListBooking(response: Response): Promise<AdminBookingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdminBookingDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminBookingDTO>(<any>null);
    }

    deleteBooking(id: string): Promise<ViewBookingDTO> {
        let url_ = this.baseUrl + "/api/admin/AdminBooking/bookings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBooking(_response);
        });
    }

    protected processDeleteBooking(response: Response): Promise<ViewBookingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ViewBookingDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewBookingDTO>(<any>null);
    }

    listBookings(startDateRange: string | null | undefined, endDateRange: string | null | undefined, startTime: string | undefined, endTime: string | undefined, offset: number | undefined, count: number | undefined, all: boolean | undefined): Promise<ViewBookingDTO[]> {
        let url_ = this.baseUrl + "/api/admin/AdminBooking/bookings?";
        if (startDateRange !== undefined && startDateRange !== null)
            url_ += "startDateRange=" + encodeURIComponent("" + startDateRange) + "&";
        if (endDateRange !== undefined && endDateRange !== null)
            url_ += "endDateRange=" + encodeURIComponent("" + endDateRange) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent("" + startTime) + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent("" + endTime) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (all === null)
            throw new Error("The parameter 'all' cannot be null.");
        else if (all !== undefined)
            url_ += "all=" + encodeURIComponent("" + all) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListBookings(_response);
        });
    }

    protected processListBookings(response: Response): Promise<ViewBookingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ViewBookingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewBookingDTO[]>(<any>null);
    }
}

export class ImageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    image(): Promise<string> {
        let url_ = this.baseUrl + "/api/admin/Image";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImage(_response);
        });
    }

    protected processImage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class ProductsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    getProducts(): Promise<AdminProductDTO[]> {
        let url_ = this.baseUrl + "/api/admin/Products";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: Response): Promise<AdminProductDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdminProductDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminProductDTO[]>(<any>null);
    }

    addProduct(product: AdminProductDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/Products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddProduct(_response);
        });
    }

    protected processAddProduct(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getProductById(id: string): Promise<AdminProductDTO> {
        let url_ = this.baseUrl + "/api/admin/Products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductById(_response);
        });
    }

    protected processGetProductById(response: Response): Promise<AdminProductDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdminProductDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminProductDTO>(<any>null);
    }

    editProduct(id: string, product: AdminProductDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/Products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditProduct(_response);
        });
    }

    protected processEditProduct(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteProduct(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/Products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteProduct(_response);
        });
    }

    protected processDeleteProduct(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    autoCompleteCategories(searchTerm: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/admin/Products/autocompletecategories?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCompleteCategories(_response);
        });
    }

    protected processAutoCompleteCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    autoCompleteSubCategories(searchTerm: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/admin/Products/autocompletesubcategories?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCompleteSubCategories(_response);
        });
    }

    protected processAutoCompleteSubCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class ProductVariantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    addProducVariant(productId: string, productVariant: ProductVariant): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/ProductVariant/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productVariant);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddProducVariant(_response);
        });
    }

    protected processAddProducVariant(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    gerProductVariantsAll(productId: string): Promise<ProductVariant[]> {
        let url_ = this.baseUrl + "/api/admin/ProductVariant/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGerProductVariantsAll(_response);
        });
    }

    protected processGerProductVariantsAll(response: Response): Promise<ProductVariant[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductVariant[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductVariant[]>(<any>null);
    }

    gerProductVariants(productId: string, variantId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/ProductVariant/{productId}/{variantId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (variantId === undefined || variantId === null)
            throw new Error("The parameter 'variantId' must be defined.");
        url_ = url_.replace("{variantId}", encodeURIComponent("" + variantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGerProductVariants(_response);
        });
    }

    protected processGerProductVariants(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class AuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    authenticate(loginViewModel: LoginViewModel): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginViewModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    createUser(model: SignUpModelForJolse): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/createuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    confirmEmail(userId: string | null, code: string | null): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/confirmemail/{userId}/{code}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    changePassword(cpvm: ChangePasswordViewModel): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/changepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cpvm);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }

    forgotPassword(model: ForgotPasswordViewModel): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/forgotpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    resetPassword(model: ResetPasswordForJolse): Promise<AuthViewModel> {
        let url_ = this.baseUrl + "/api/Auth/resetpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<AuthViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthViewModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthViewModel>(<any>null);
    }
}

export class BookingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    removeUnpaidBookings(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Booking/RemoveBookings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUnpaidBookings(_response);
        });
    }

    protected processRemoveUnpaidBookings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    addBooking(bookingDTO: BookingDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/Booking/addbooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBooking(_response);
        });
    }

    protected processAddBooking(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    listBookingSlots(availableSpots: number | undefined, startDateRange: string | null | undefined, endDateRange: string | null | undefined, offset: number | undefined, count: number | undefined): Promise<AvailabilityDTO[]> {
        let url_ = this.baseUrl + "/api/Booking/availability?";
        if (availableSpots === null)
            throw new Error("The parameter 'availableSpots' cannot be null.");
        else if (availableSpots !== undefined)
            url_ += "availableSpots=" + encodeURIComponent("" + availableSpots) + "&";
        if (startDateRange !== undefined && startDateRange !== null)
            url_ += "startDateRange=" + encodeURIComponent("" + startDateRange) + "&";
        if (endDateRange !== undefined && endDateRange !== null)
            url_ += "endDateRange=" + encodeURIComponent("" + endDateRange) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListBookingSlots(_response);
        });
    }

    protected processListBookingSlots(response: Response): Promise<AvailabilityDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AvailabilityDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailabilityDTO[]>(<any>null);
    }

    getBookingConfiguration(): Promise<BookingConfigurationDTO> {
        let url_ = this.baseUrl + "/api/Booking/bookingconfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBookingConfiguration(_response);
        });
    }

    protected processGetBookingConfiguration(response: Response): Promise<BookingConfigurationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BookingConfigurationDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingConfigurationDTO>(<any>null);
    }
}

export class CartClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    addCart(cart: Cart): Promise<string> {
        let url_ = this.baseUrl + "/api/Cart/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cart);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCart(_response);
        });
    }

    protected processAddCart(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    updateCartItem(item: CartItemDTO): Promise<CartItem> {
        let url_ = this.baseUrl + "/api/Cart/cartitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCartItem(_response);
        });
    }

    protected processUpdateCartItem(response: Response): Promise<CartItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartItem>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartItem>(<any>null);
    }

    addItemToCart(item: CartItemDTO): Promise<CartItem> {
        let url_ = this.baseUrl + "/api/Cart/cartitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddItemToCart(_response);
        });
    }

    protected processAddItemToCart(response: Response): Promise<CartItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartItem>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartItem>(<any>null);
    }

    deleteCartItem(item: CartItemDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Cart/removecartitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCartItem(_response);
        });
    }

    protected processDeleteCartItem(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    convertCartToSale(cartDTO: ConvertCartDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/Cart/convertcart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cartDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConvertCartToSale(_response);
        });
    }

    protected processConvertCartToSale(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    convertCartToSubscription(cartDTO: ConvertCartDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/Cart/convertcartosub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cartDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConvertCartToSubscription(_response);
        });
    }

    protected processConvertCartToSubscription(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    getCartItems(): Promise<CartForJolse> {
        let url_ = this.baseUrl + "/api/Cart/cartitems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCartItems(_response);
        });
    }

    protected processGetCartItems(response: Response): Promise<CartForJolse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartForJolse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartForJolse>(<any>null);
    }

    calculateCost(pickup: boolean | undefined, username: string | null | undefined): Promise<Cart> {
        let url_ = this.baseUrl + "/api/Cart?";
        if (pickup === null)
            throw new Error("The parameter 'pickup' cannot be null.");
        else if (pickup !== undefined)
            url_ += "pickup=" + encodeURIComponent("" + pickup) + "&";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculateCost(_response);
        });
    }

    protected processCalculateCost(response: Response): Promise<Cart> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Cart>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cart>(<any>null);
    }
}

export class ClubPackClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    getClubPacks(business: string | null | undefined, customerId: string | null | undefined): Promise<ClubPack[]> {
        let url_ = this.baseUrl + "/api/ClubPack/packs?";
        if (business !== undefined && business !== null)
            url_ += "business=" + encodeURIComponent("" + business) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClubPacks(_response);
        });
    }

    protected processGetClubPacks(response: Response): Promise<ClubPack[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ClubPack[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPack[]>(<any>null);
    }

    getProductBoxes(business: string | null | undefined): Promise<ProductBox[]> {
        let url_ = this.baseUrl + "/api/ClubPack/productboxes?";
        if (business !== undefined && business !== null)
            url_ += "business=" + encodeURIComponent("" + business) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductBoxes(_response);
        });
    }

    protected processGetProductBoxes(response: Response): Promise<ProductBox[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductBox[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductBox[]>(<any>null);
    }

    getBox(id: string): Promise<ClubPackBox> {
        let url_ = this.baseUrl + "/api/ClubPack/box/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBox(_response);
        });
    }

    protected processGetBox(response: Response): Promise<ClubPackBox> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ClubPackBox>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPackBox>(<any>null);
    }

    getPack(id: string, includeBoxes: boolean | undefined): Promise<ClubPack> {
        let url_ = this.baseUrl + "/api/ClubPack/pack/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeBoxes === null)
            throw new Error("The parameter 'includeBoxes' cannot be null.");
        else if (includeBoxes !== undefined)
            url_ += "includeBoxes=" + encodeURIComponent("" + includeBoxes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPack(_response);
        });
    }

    protected processGetPack(response: Response): Promise<ClubPack> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ClubPack>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPack>(<any>null);
    }

    getImage(id: string, fullSize: boolean | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/image/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fullSize === null)
            throw new Error("The parameter 'fullSize' cannot be null.");
        else if (fullSize !== undefined)
            url_ += "fullSize=" + encodeURIComponent("" + fullSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImage(_response);
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    signUp(cpsu: ClubPackSignupViewModel): Promise<Customer> {
        let url_ = this.baseUrl + "/api/ClubPack/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cpsu);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignUp(_response);
        });
    }

    protected processSignUp(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Customer>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(<any>null);
    }

    getCustomer(id: string): Promise<Customer> {
        let url_ = this.baseUrl + "/api/ClubPack/customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Customer>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(<any>null);
    }

    updateCustomer(customer: Customer): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/customer/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customer);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    processRefferals(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/processrefferals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessRefferals(_response);
        });
    }

    protected processProcessRefferals(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    processClubPacks(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ClubPack/processclubpacks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessClubPacks(_response);
        });
    }

    protected processProcessClubPacks(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    addBoxToOrder(rbvm: RewardBoxViewModel): Promise<Session> {
        let url_ = this.baseUrl + "/api/ClubPack/addboxtoorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rbvm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBoxToOrder(_response);
        });
    }

    protected processAddBoxToOrder(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Session>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(<any>null);
    }

    addSubscriptionToOrder(ssvm: SubscriptionSignupViewModel): Promise<Session> {
        let url_ = this.baseUrl + "/api/ClubPack/addSubscriptionToOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ssvm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSubscriptionToOrder(_response);
        });
    }

    protected processAddSubscriptionToOrder(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Session>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(<any>null);
    }
}

export class ConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    getConfig(business: string | null): Promise<ExternalAppConfig> {
        let url_ = this.baseUrl + "/api/Config/config/{business}";
        if (business === undefined || business === null)
            throw new Error("The parameter 'business' must be defined.");
        url_ = url_.replace("{business}", encodeURIComponent("" + business));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: Response): Promise<ExternalAppConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExternalAppConfig>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalAppConfig>(<any>null);
    }

    getMethods(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Config/cartmethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMethods(_response);
        });
    }

    protected processGetMethods(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class FrontendConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    getConfig(): Promise<FrontendConfig> {
        let url_ = this.baseUrl + "/api/FrontendConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: Response): Promise<FrontendConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FrontendConfig>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendConfig>(<any>null);
    }
}

export class OrdersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    orderHistory(): Promise<OrderHistoryDTO[]> {
        let url_ = this.baseUrl + "/api/Orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrderHistory(_response);
        });
    }

    protected processOrderHistory(response: Response): Promise<OrderHistoryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderHistoryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderHistoryDTO[]>(<any>null);
    }
}

export class ProductClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    listProducts(categories: string[] | null | undefined, subcategories: string[] | null | undefined, offset: number | undefined, count: number | undefined, searchterm: string | null | undefined, all: boolean | undefined, orderBy: string | null | undefined): Promise<ProductDTO[]> {
        let url_ = this.baseUrl + "/api/Product?";
        if (categories !== undefined && categories !== null)
            categories && categories.forEach(item => { url_ += "categories=" + encodeURIComponent("" + item) + "&"; });
        if (subcategories !== undefined && subcategories !== null)
            subcategories && subcategories.forEach(item => { url_ += "subcategories=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (searchterm !== undefined && searchterm !== null)
            url_ += "searchterm=" + encodeURIComponent("" + searchterm) + "&";
        if (all === null)
            throw new Error("The parameter 'all' cannot be null.");
        else if (all !== undefined)
            url_ += "all=" + encodeURIComponent("" + all) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListProducts(_response);
        });
    }

    protected processListProducts(response: Response): Promise<ProductDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDTO[]>(<any>null);
    }

    categories(category: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Product/categories?";
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories(_response);
        });
    }

    protected processCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    autoCompleteCategories(searchTerm: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Product/autocompletecategories?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCompleteCategories(_response);
        });
    }

    protected processAutoCompleteCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    autoCompleteSubCategories(searchTerm: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Product/autocompletesubcategories?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoCompleteSubCategories(_response);
        });
    }

    protected processAutoCompleteSubCategories(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class StripeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    doDesionStuff(customerId: string): Promise<Session> {
        let url_ = this.baseUrl + "/api/Stripe/session/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDoDesionStuff(_response);
        });
    }

    protected processDoDesionStuff(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Session>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(<any>null);
    }
}

export class StripeWebHooksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:7196";
    }

    index(stripeBusinessName: string | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/{stripeBusinessName}/StripeWebHooks";
        if (stripeBusinessName === undefined || stripeBusinessName === null)
            throw new Error("The parameter 'stripeBusinessName' must be defined.");
        url_ = url_.replace("{stripeBusinessName}", encodeURIComponent("" + stripeBusinessName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export interface AdminBookingDTO {
    id?: string | undefined;
    bookingSlotId: string;
    number: number;
    date: string;
    fullName: string;
    emailAddress: string;
    mobileNumber: string;
    comments?: string | undefined;
    bookingType: BookingType;
}

export enum BookingType {
    Web = "Web",
    Bar = "Bar",
}

export interface ViewBookingDTO {
    id: string;
    bookingDate: string;
    startTime: string;
    endTime: string;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    mobilePhone?: string | undefined;
    depositPaid: boolean;
    deposit: number;
    number: number;
    createdDateTime: string;
    bookingType: BookingType;
    comments?: string | undefined;
}

export interface AdminProductDTO {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    costPrice: number;
    sellPrice: number;
    tax: number;
    active: boolean;
    showRemainingUnitsOnShop: boolean;
    applyMaximumPurchaseNumber: boolean;
    maxPurchaseUnits: number;
    imageId?: string | undefined;
    currentUnits: number;
}

export interface ProductVariant {
    id: string;
    name?: string | undefined;
    quantity: number;
    shortDescription?: string | undefined;
    amount: number;
    imageId?: string | undefined;
    image?: ImageFile | undefined;
    active: boolean;
}

export interface ImageFile {
    id: string;
    title?: string | undefined;
}

export interface AuthViewModel {
    token?: string | undefined;
    customerId?: string | undefined;
}

export interface LoginViewModel {
    email: string;
    password: string;
    rememberMe: boolean;
}

export interface SignUpModelForJolse {
    email: string;
    password: string;
    confirmPassword?: string | undefined;
    referrer?: string | undefined;
    confirmAccountUrl: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string | undefined;
    dateOfBirth: string;
}

export interface ChangePasswordViewModel {
    oldPassword: string;
    newPassword: string;
    confirmPassword?: string | undefined;
}

export interface ForgotPasswordViewModel {
    email: string;
    restPasswordUrl?: string | undefined;
}

export interface ResetPasswordForJolse {
    userId?: string | undefined;
    password: string;
    confirmPassword?: string | undefined;
    code?: string | undefined;
}

export interface BookingDTO {
    bookingSlotId: string;
    number: number;
    date: string;
    fullName: string;
    emailAddress: string;
    mobileNumber: string;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
}

export interface AvailabilityDTO {
    date: string;
    bookingSlots?: BookingSlotDTO[] | undefined;
}

export interface BookingSlotDTO {
    id: string;
    startTime: string;
    endTime: string;
    maxCapacity: number;
    availability: number;
    date: string;
}

export interface BookingConfigurationDTO {
    maxBookingPerOrder: number;
    termsAndConditions?: string | undefined;
}

export interface Cart {
    id: string;
    cartItems?: CartItem[] | undefined;
    customerId?: string | undefined;
    username?: string | undefined;
    guest: boolean;
    shippingAddress?: Address | undefined;
    billingAddress?: Address | undefined;
}

export interface CartItem {
    id: string;
    product?: Product | undefined;
    quantity: number;
    cartTotal: number;
}

export interface Product {
    productID: string;
    name: string;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    tax: number;
    imageId?: string | undefined;
    variants?: ProductVariant[] | undefined;
    active: boolean;
    showRemainingUnitsOnShop: boolean;
    applyMaximumPurchaseNumber: boolean;
    maxPurchaseUnits: number;
    dataFields?: CustomDataField[] | undefined;
    fullProductName?: string | undefined;
}

export interface CustomDataField {
    name?: string | undefined;
    value?: string | undefined;
}

export interface Address {
    addressId: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postcode: number;
}

export interface CartItemDTO {
    productId: string;
    quantity: number;
}

export interface ConvertCartDTO {
    username?: string | undefined;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
    pickup: boolean;
}

export interface CartForJolse {
    cartItems?: CartItem[] | undefined;
    customerId?: string | undefined;
    postage?: PostageForJolse | undefined;
}

export interface PostageForJolse {
    description?: string | undefined;
    amount: number;
}

export interface ClubPack {
    id: string;
    name?: string | undefined;
    price: number;
    description?: string | undefined;
    boxes?: ClubPackBox[] | undefined;
    active: boolean;
    customerIsSubscribed: boolean;
    customCustomerSubscription: boolean;
    stripePlanId?: string | undefined;
}

export interface ClubPackBox {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    active: boolean;
    future: boolean;
    imageId?: string | undefined;
    items?: ClubPackLine[] | undefined;
    boxMonth?: string | undefined;
    referrerBox: boolean;
    referrerCreditRequired: number;
}

export interface ClubPackLine {
    id: string;
    quantity: number;
    product?: Product | undefined;
    amount: number;
}

export interface ProductBox {
    id: string;
    customer?: Customer | undefined;
    price: number;
    name?: string | undefined;
    description?: string | undefined;
    active: boolean;
    imageId?: string | undefined;
    items?: ClubPackLine[] | undefined;
}

export interface Customer {
    customerID: string;
    firstName?: string | undefined;
    lastName: string;
    emailAddress?: string | undefined;
    homePhone?: string | undefined;
    mobilePhone?: string | undefined;
    postalAddress?: Address | undefined;
    billingAddress?: Address | undefined;
    fullName?: string | undefined;
    applyWet: boolean;
    customPriceLevel: boolean;
    productPriceLevel?: ProductPriceLevel | undefined;
    billingSameAsPostal: boolean;
    totalReferralCount: number;
    currentReferralCreditCount: number;
    referrals?: CustomerReferral[] | undefined;
    stripeCustomerId?: string | undefined;
    signUpDate: string;
    notes?: string | undefined;
    dateOfBirth?: string | undefined;
}

export interface ProductPriceLevel {
    productPriceLevelID: string;
    name?: string | undefined;
    description?: string | undefined;
    business?: Business | undefined;
}

export interface Business {
    businessID: string;
    name: string;
    registeredAddress?: Address | undefined;
    streetSameAsRegistered: boolean;
    streetAddress?: Address | undefined;
    emailAddress: string;
    homePhone?: string | undefined;
    mobilePhone?: string | undefined;
    abn: string;
    applyGST: boolean;
    productPriceIncludesGST: boolean;
    taxAmount: number;
    applyWET: boolean;
    wetAmount: number;
    defaultPaymentTerms: number;
    invoiceLayoutDetails?: InvoiceLayoutDetails | undefined;
    percentDiscount: number;
    numOfItems: number;
    stripeId?: string | undefined;
    shortName?: string | undefined;
    stripeAPIKey?: string | undefined;
    stripeWebHookKey?: string | undefined;
    sendGridAPIKey?: string | undefined;
    sendgridInvoiceTemplateId?: string | undefined;
    sendgridOrderReadyTemplateId?: string | undefined;
    sendgridOrderReceivedTemplateId?: string | undefined;
    sendOrderReadyEmail: boolean;
    sendOrderReceivedEmail: boolean;
    showOutstandingOrdersOnDashBoard: boolean;
    showOutstandingInvoicesOnDashBoard: boolean;
    hostName?: string | undefined;
    productNameFormat?: string | undefined;
    shopConfiguration?: ShopConfiguration | undefined;
    bookingConfiguration?: BookingConfiguration | undefined;
}

export interface InvoiceLayoutDetails {
    invoiceLayDetailsID: string;
    paymentTermsText?: string | undefined;
    termsAndConditions?: string | undefined;
    logo?: string | undefined;
    bankDetails?: BankDetails | undefined;
}

export interface BankDetails {
    bankDetailsId: string;
    business?: Business | undefined;
    accountName?: string | undefined;
    bsb?: string | undefined;
    accountNumber?: string | undefined;
}

export interface ShopConfiguration {
    id: string;
    logoImageId?: string | undefined;
    logoImage?: ImageFile | undefined;
    ageGateImageId?: string | undefined;
    ageGateImage?: ImageFile | undefined;
    headerImageId?: string | undefined;
    headerImage?: ImageFile | undefined;
    shopName?: string | undefined;
    enableProducts: boolean;
    enableSubscriptions: boolean;
    enableSpecials: boolean;
    enableDelivery: boolean;
    instagramId?: string | undefined;
    instagramUser?: string | undefined;
}

export interface BookingConfiguration {
    id: string;
    depositAmount: number;
    defaultCapacityAmount: number;
    bookingConfirmationTemplateId?: string | undefined;
    maxBookingNumber: number;
    timeBeforeBooking: number;
    termsAndConditions?: string | undefined;
}

export interface CustomerReferral {
    id: string;
    customerId: string;
    customer?: Customer | undefined;
    verificationCode?: string | undefined;
    active: boolean;
    utilised: boolean;
    usernameReferred?: string | undefined;
}

export interface ClubPackSignupViewModel {
    customer?: Customer | undefined;
    clubPackId?: string | undefined;
    username?: string | undefined;
}

export interface StripeEntity {
}

export interface Session extends StripeEntity {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** Specify whether Checkout should collect the customer’s billing address. If set to
required, Checkout will always collect the customer’s billing address. If left
blank or set to auto Checkout will only collect the billing address when
necessary. */
    billing_address_collection?: string | undefined;
    /** The URL the customer will be directed to if they decide to go back to your website. */
    cancel_url?: string | undefined;
    /** A unique string to reference the Checkout Session. This can be a customer ID, a cart
ID, or similar. It is included in the checkout.session.completed webhook and can
be used to fulfill the purchase. */
    client_reference_id?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** The email address used to create the customer object. */
    customer_email?: string | undefined;
    /** The line items, plans, or SKUs that were purchased by the customer. */
    display_items?: SessionDisplayItem[] | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** The IETF language tag of the locale Checkout is displayed in. If blank or auto,
the browser’s locale is used. */
    locale?: string | undefined;
    /** The mode of the Checkout Session which can be payment, setup, or
subscription. */
    mode?: string | undefined;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    /** The list of payment method types (e.g. card) that this Checkout Session is allowed to
use. */
    payment_method_types?: string[] | undefined;
    setup_intent?: ExpandableFieldOfSetupIntent | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
    /** Describes the type of transaction being performed by Checkout in
order to customize relevant text on the page, such as the Submit
button. submit_type can only be specified on checkout
sessions using line items or a SKU, and not checkout sessions for
subscriptions. Supported values are auto, book,
donate, or pay. */
    submit_type?: string | undefined;
    /** The URL the customer will be directed to after a successful payment. */
    success_url?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfCustomer {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Customer2 | undefined;
}

export interface StripeEntityOfCustomer extends StripeEntity {
}

export interface Customer2 extends StripeEntityOfCustomer {
    id?: string | undefined;
    object?: string | undefined;
    account_balance: number;
    /** The customer’s address. */
    address?: Address2 | undefined;
    /** Current balance, if any, being stored on the customer. If negative, the customer has
credit to apply to their next invoice. If positive, the customer has an amount owed that
will be added to their next invoice. The balance does not refer to any unpaid invoices;
it solely takes into account amounts that have yet to be successfully applied to any
invoice. This balance is only taken into account as invoices are finalized. */
    balance: number;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created: string;
    /** The currency the customer can be charged in for recurring billing purposes */
    currency?: string | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    /** Warning: this is not in the documentation */
    default_source_type?: string | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    /** Whether or not the latest charge for the customer’s latest invoice has failed */
    delinquent: boolean;
    /** An arbitrary string attached to the object. Often useful for displaying to users. */
    description?: string | undefined;
    /** Describes the current discount active on the customer, if there is one */
    discount?: Discount | undefined;
    /** The customer’s email address. */
    email?: string | undefined;
    /** The prefix for the customer used to generate unique invoice numbers. */
    invoice_prefix?: string | undefined;
    /** The customer’s default invoice settings. */
    invoice_settings?: CustomerInvoiceSettings | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** A set of key/value pairs that you can attach to a customer object. It can be useful for
storing additional information about the customer in a structured format */
    metadata?: { [key: string]: string; } | undefined;
    /** The customer’s full name or business name. */
    name?: string | undefined;
    /** The customer’s phone number. */
    phone?: string | undefined;
    /** The customer’s preferred locales (languages), ordered by preference. */
    preferred_locales?: string[] | undefined;
    /** Mailing and shipping address for the customer. Appears on invoices emailed to this
customer. */
    shipping?: Shipping | undefined;
    /** The customer’s payment sources, if any */
    sources?: StripeListOfIPaymentSource | undefined;
    /** The customer’s current subscriptions, if any */
    subscriptions?: StripeListOfSubscription | undefined;
    /** Describes the customer’s tax exemption status. One of none, exempt, or
reverse. */
    tax_exempt?: string | undefined;
    /** The customer’s current tax ids, if any. */
    tax_ids?: StripeListOfTaxId | undefined;
    /** The customer’s tax information. Appears on invoices emailed to this customer. */
    tax_info?: CustomerTaxInfo | undefined;
    /** Describes the status of looking up the tax ID provided in tax_info. */
    tax_info_verification?: CustomerTaxInfoVerification | undefined;
}

export interface StripeEntityOfAddress extends StripeEntity {
}

export interface Address2 extends StripeEntityOfAddress {
    city?: string | undefined;
    country?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postal_code?: string | undefined;
    state?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfIPaymentSource {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: IPaymentSource | undefined;
}

/** Resources that implement this interface can be used as payment sources when creating charges. Possible concrete classes: */
export interface IPaymentSource {
}

export interface StripeEntityOfDiscount extends StripeEntity {
}

export interface Discount extends StripeEntityOfDiscount {
    object?: string | undefined;
    coupon?: Coupon | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    end?: string | undefined;
    start?: string | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
}

export interface StripeEntityOfCoupon extends StripeEntity {
}

export interface Coupon extends StripeEntityOfCoupon {
    id?: string | undefined;
    object?: string | undefined;
    amount_off?: number | undefined;
    created: string;
    currency?: string | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    duration?: string | undefined;
    duration_in_months?: number | undefined;
    livemode: boolean;
    max_redemptions?: number | undefined;
    metadata?: { [key: string]: string; } | undefined;
    name?: string | undefined;
    percent_off?: number | undefined;
    redeem_by?: string | undefined;
    times_redeemed: number;
    valid: boolean;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfSubscription {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Subscription | undefined;
}

export interface StripeEntityOfSubscription extends StripeEntity {
}

export interface Subscription extends StripeEntityOfSubscription {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** A non-negative decimal between 0 and 100, with at most two decimal places. This
represents the percentage of the subscription invoice subtotal that will be transferred
to the application owner’s Stripe account. */
    application_fee_percent?: number | undefined;
    /** This field has been renamed to CollectionMethod and will be removed
in a future API version. */
    billing?: Billing | undefined;
    billing_cycle_anchor?: string | undefined;
    /** Define thresholds at which an invoice will be sent, and the subscription advanced to a
new billing period */
    billing_thresholds?: SubscriptionBillingThresholds | undefined;
    /** A date in the future at which the subscription will automatically get canceled. */
    cancel_at?: string | undefined;
    cancel_at_period_end: boolean;
    canceled_at?: string | undefined;
    /** Either charge_automatically, or send_invoice. When
charging automatically, Stripe will attempt to pay this subscription
at the end of the cycle using the default source attached to the
customer.  When sending an invoice, Stripe will email your customer
an invoice with payment instructions. */
    collection_method?: string | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created?: string | undefined;
    /** End of the current period that the subscription has been invoiced for. At the end of
this period, a new invoice will be created. */
    current_period_end?: string | undefined;
    /** Start of the current period that the subscription has been invoiced for. */
    current_period_start?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** Number of days a customer has to pay invoices generated by this subscription. This value will be null for subscriptions where billing=charge_automatically. */
    days_until_due?: number | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    /** The tax rates that will apply to any subscription item that does not have
tax_rates set. Invoices created will have their default_tax_rates
populated from the subscription. */
    default_tax_rates?: TaxRate[] | undefined;
    /** Describes the current discount applied to this subscription, if there is one. When
billing, a discount applied to a subscription overrides a discount applied on a
customer-wide basis. */
    discount?: Discount | undefined;
    /** If the subscription has ended, the date the subscription ended. */
    ended_at?: string | undefined;
    /** List of subscription items, each with an attached plan. */
    items?: StripeListOfSubscriptionItem | undefined;
    latest_invoice?: ExpandableFieldOfInvoice | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** A set of key/value pairs that you can attach to a subscription object. */
    metadata?: { [key: string]: string; } | undefined;
    pending_setup_intent?: ExpandableFieldOfSetupIntent | undefined;
    /** Plan the customer is subscribed to. Only set if the subscription contains a single plan. */
    plan?: Plan | undefined;
    /** The quantity of the plan to which the customer is subscribed. Only set if the
subscription contains a single plan. */
    quantity?: number | undefined;
    schedule?: ExpandableFieldOfSubscriptionSchedule | undefined;
    start?: string | undefined;
    /** Date when the subscription was first created. The date might differ from the
created date due to backdating. */
    start_date?: string | undefined;
    /** Possible values are incomplete, incomplete_expired, trialing,
active, past_due, canceled, or unpaid. */
    status?: string | undefined;
    tax_percent?: number | undefined;
    /** If specified, the funds from the subscription’s invoices will be transferred to the
destination and the ID of the resulting transfers will be found on the resulting
charges. */
    transfer_data?: SubscriptionTransferData | undefined;
    /** If the subscription has a trial, the end of that trial. */
    trial_end?: string | undefined;
    /** If the subscription has a trial, the beginning of that trial. */
    trial_start?: string | undefined;
}

/** The field this enum was used for has been renamed to CollectionMethod and now accepts string. */
export enum Billing {
    ChargeAutomatically = "charge_automatically",
    SendInvoice = "send_invoice",
}

export interface StripeEntityOfSubscriptionBillingThresholds extends StripeEntity {
}

export interface SubscriptionBillingThresholds extends StripeEntityOfSubscriptionBillingThresholds {
    /** Monetary threshold that triggers the subscription to advance to a new billing period. */
    amount_gte?: number | undefined;
    /** Indicates if the billing_cycle_anchor should be reset when a threshold is
reached. If true, billing_cycle_anchor will be updated to the date/time
the threshold was last reached; otherwise, the value will remain unchanged. This value
may not be true if the subscription contains items with plans that have
aggregate_usage=last_ever. */
    reset_billing_cycle_anchor?: boolean | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfPaymentMethod {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: PaymentMethod | undefined;
}

export interface PaymentMethod extends StripeEntity {
    id?: string | undefined;
    object?: string | undefined;
    billing_details?: BillingDetails | undefined;
    card?: PaymentMethodCard | undefined;
    card_present?: PaymentMethodCardPresent | undefined;
    created?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    type?: string | undefined;
}

export interface BillingDetails extends StripeEntity {
    address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
}

export interface PaymentMethodCard extends StripeEntity {
    brand?: string | undefined;
    checks?: PaymentMethodCardChecks | undefined;
    country?: string | undefined;
    exp_month: number;
    exp_year: number;
    fingerprint?: string | undefined;
    funding?: string | undefined;
    last4?: string | undefined;
    three_d_secure_usage?: PaymentMethodCardThreeDSecureUsage | undefined;
    wallet?: PaymentMethodCardWallet | undefined;
}

export interface PaymentMethodCardChecks extends StripeEntity {
    address_line1_check?: string | undefined;
    address_postal_code_check?: string | undefined;
    cvc_check?: string | undefined;
}

export interface PaymentMethodCardThreeDSecureUsage extends StripeEntity {
    supported?: boolean | undefined;
}

export interface PaymentMethodCardWallet extends StripeEntity {
    amex_express_checkout?: PaymentMethodCardWalletAmexExpressCheckout | undefined;
    apple_pay?: PaymentMethodCardWalletApplePay | undefined;
    dynamic_last4?: string | undefined;
    google_pay?: PaymentMethodCardWalletGooglePay | undefined;
    masterpass?: PaymentMethodCardWalletMasterpass | undefined;
    samsung_pay?: PaymentMethodCardWalletSamsungPay | undefined;
    type?: string | undefined;
    visa_checkout?: PaymentMethodCardWalletVisaCheckout | undefined;
}

export interface PaymentMethodCardWalletAmexExpressCheckout extends StripeEntity {
}

export interface PaymentMethodCardWalletApplePay extends StripeEntity {
}

export interface PaymentMethodCardWalletGooglePay extends StripeEntity {
}

export interface PaymentMethodCardWalletMasterpass extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface PaymentMethodCardWalletSamsungPay extends StripeEntity {
}

export interface PaymentMethodCardWalletVisaCheckout extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface PaymentMethodCardPresent extends StripeEntity {
}

export interface TaxRate extends StripeEntity {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** Whether the tax rate is currently available for new subscriptions. */
    active: boolean;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created?: string | undefined;
    /** An arbitrary string attached to the tax rate for your internal use only. It will not be
visible to your customers. */
    description?: string | undefined;
    /** The display name of the tax rates as it will appear to your customer on their receipt
email, PDF, and the hosted invoice page. */
    display_name?: string | undefined;
    /** This specifies if the tax rate is inclusive or exclusive. */
    inclusive: boolean;
    /** The jurisdiction for the tax rate. */
    jurisdiction?: string | undefined;
    /** Has the value true if the object exists in live mode or the value false
if the object exists in test mode. */
    livemode: boolean;
    /** Set of key-value pairs that you can attach to an object. This can be useful for storing
additional information about the object in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** This represents the tax rate percent out of 100. */
    percentage: number;
}

export interface StripeEntityOfStripeListOfSubscriptionItem extends StripeEntity {
}

export interface StripeListOfSubscriptionItem extends StripeEntityOfStripeListOfSubscriptionItem {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: SubscriptionItem[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfSubscriptionItem extends StripeEntity {
}

export interface SubscriptionItem extends StripeEntityOfSubscriptionItem {
    id?: string | undefined;
    object?: string | undefined;
    created: string;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    metadata?: { [key: string]: string; } | undefined;
    plan?: Plan | undefined;
    quantity: number;
    subscription?: string | undefined;
    /** The tax rates which apply to the subscription item. */
    tax_rates?: TaxRate[] | undefined;
}

export interface StripeEntityOfPlan extends StripeEntity {
}

export interface Plan extends StripeEntityOfPlan {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** Whether the plan is currently available for new subscriptions. */
    active: boolean;
    /** Specifies a usage aggregation strategy for plans where UsageType is
metered. Allowed values are sum for summing up all usage during a period,
last_during_period for picking the last usage record reported within a period,
last_ever for picking the last usage record ever (across period bounds) or
max which picks the usage record with the maximum reported usage during a
period. Defaults to sum. */
    aggregate_usage?: string | undefined;
    /** The amount in cents to be charged on the interval specified. */
    amount?: number | undefined;
    /** Same as Amount, but contains a decimal value with at most 12 decimal
places. */
    amount_decimal?: number | undefined;
    /** Describes how to compute the price per period. Either per_unit or tiered.
per_unit indicates that the fixed amount (specified in amount) will be charged
per unit in quantity (for plans with usage_type=licensed), or per unit of total usage
(for plans with usage_type=metered). tiered indicates that the unit pricing will
be computed using a tiering strategy as defined using the Tiers and
TiersMode attributes. */
    billing_scheme?: string | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created: string;
    /** Three-letter ISO currency code, in lowercase. Must be a supported currency. */
    currency?: string | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    /** One of day, week, month or year. The frequency with which a
subscription should be billed. */
    interval?: string | undefined;
    /** The number of intervals (specified in the interval property) between subscription
billings. */
    interval_count: number;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** A set of key/value pairs that you can attach to a subscription object. */
    metadata?: { [key: string]: string; } | undefined;
    /** A brief description of the plan, hidden from customers. */
    nickname?: string | undefined;
    product?: ExpandableFieldOfProduct | undefined;
    /** Each element represents a pricing tier. This parameter requires BillingScheme
to be set to tiered. */
    tiers?: PlanTier[] | undefined;
    /** Defines if the tiering price should be graduated or volume based. In
volume-based tiering, the maximum quantity within a period determines the per unit
price, in graduated tiering pricing can successively change as the quantity
grows. */
    tiers_mode?: string | undefined;
    /** Apply a transformation to the reported usage or set quantity before computing the
billed price. Cannot be combined with Tiers. */
    transform_usage?: PlanTransformUsage | undefined;
    /** Default number of trial days when subscribing a customer to this plan using
trial_from_plan=true. */
    trial_period_days?: number | undefined;
    /** Configures how the quantity per period should be determined, can be either
            metered or licensed. licensed will automatically bill the quantity
            set for a plan when adding it to a subscription, metered will aggregate the total
            usage based on usage records. Defaults to licensed.
             */
    usage_type?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfProduct {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Product2 | undefined;
}

export interface StripeEntityOfProduct extends StripeEntity {
}

export interface Product2 extends StripeEntityOfProduct {
    id?: string | undefined;
    object?: string | undefined;
    /** Whether or not the product is currently available for purchase. */
    active?: boolean | undefined;
    /** A list of up to 5 attributes that each SKU can provide values for (e.g. ["color", "size"]). */
    attributes?: string[] | undefined;
    /** A short one-line description of the product, meant to be displayable to the customer. */
    caption?: string | undefined;
    /** Time at which the object was created. */
    created: string;
    /** An array of connect application identifiers that cannot purchase this product. */
    deactivate_on?: string[] | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    /** The product’s description, meant to be displayable to the customer. */
    description?: string | undefined;
    /** A list of up to 8 URLs of images for this product, meant to be displayable to the customer. */
    images?: string[] | undefined;
    /** Flag indicating whether the object exists in live mode or test mode. */
    livemode: boolean;
    /** Set of key/value pairs that you can attach to an object. It can be useful for storing additional information about the object in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** The product’s name, meant to be displayable to the customer. */
    name?: string | undefined;
    /** The dimensions of this product for shipping purposes. A SKU associated with this product can override this value by having its own package_dimensions. */
    package_dimensions?: PackageDimensions | undefined;
    /** Whether this product is a shipped good. */
    shippable?: boolean | undefined;
    /** What appears on a customer's credit card statement. */
    statement_descriptor?: string | undefined;
    /** The type of the Product. Either 'good' or 'service'. */
    type?: string | undefined;
    /** This represents a unit of this product, such as a seat or API call, on customers' receipts and invoices. */
    unit_label?: string | undefined;
    updated: string;
    /** A URL of a publicly-accessible webpage for this product. */
    url?: string | undefined;
}

export interface StripeEntityOfPackageDimensions extends StripeEntity {
}

export interface PackageDimensions extends StripeEntityOfPackageDimensions {
    height?: number | undefined;
    length?: number | undefined;
    weight?: number | undefined;
    width?: number | undefined;
}

export interface StripeEntityOfPlanTier extends StripeEntity {
}

export interface PlanTier extends StripeEntityOfPlanTier {
    /** Price for the entire tier. */
    flat_amount?: number | undefined;
    /** Same as FlatAmount, but contains a decimal value with at most 12 decimal
places. */
    flat_amount_decimal?: number | undefined;
    /** Per unit price for units relevant to the tier. */
    unit_amount?: number | undefined;
    /** Same as UnitAmount, but contains a decimal value with at most 12 decimal
places. */
    unit_amount_decimal?: number | undefined;
    /** Up to and including to this quantity will be contained in the tier. */
    up_to?: number | undefined;
}

export interface StripeEntityOfPlanTransformUsage extends StripeEntity {
}

export interface PlanTransformUsage extends StripeEntityOfPlanTransformUsage {
    divide_by: number;
    round?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfInvoice {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Invoice | undefined;
}

export interface StripeEntityOfInvoice extends StripeEntity {
}

export interface Invoice extends StripeEntityOfInvoice {
    id?: string | undefined;
    object?: string | undefined;
    /** The country of the business associated with this invoice, most often the business
creating the invoice. */
    account_country?: string | undefined;
    /** The public name of the business associated with this invoice, most often the business
creating the invoice */
    account_name?: string | undefined;
    amount_due: number;
    amount_paid: number;
    amount_remaining: number;
    /** The amount of the application application fee (if any) for the invoice. See the Connect documentation for details. */
    application_fee_amount?: number | undefined;
    attempt_count: number;
    attempted: boolean;
    auto_advance: boolean;
    /** This field has been renamed to CollectionMethod and will be removed
in a future API version. */
    billing?: Billing | undefined;
    billing_reason?: string | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    /** Either charge_automatically, or send_invoice. When
charging automatically, Stripe will attempt to pay this invoice
using the default source attached to the customer. When sending an
invoice, Stripe will email this invoice to the customer with payment
instructions. Defaults to charge_automatically. */
    collection_method?: string | undefined;
    created: string;
    currency?: string | undefined;
    custom_fields?: InvoiceCustomField[] | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** The customer’s address. Until the invoice is finalized, this field will equal
Address. Once the invoice is finalized, this field will no
longer be updated. */
    customer_address?: Address2 | undefined;
    /** The customer’s email. Until the invoice is finalized, this field will equal
Email. Once the invoice is finalized, this field will no longer
be updated. */
    customer_email?: string | undefined;
    /** The customer’s name. Until the invoice is finalized, this field will equal
Name. Once the invoice is finalized, this field will no longer
be updated. */
    customer_name?: string | undefined;
    /** The customer’s phone number. Until the invoice is finalized, this field will equal
Phone. Once the invoice is finalized, this field will no longer
be updated. */
    customer_phone?: string | undefined;
    /** The customer’s shipping information. Until the invoice is finalized, this field will
equal Shipping. Once the invoice is finalized, this field will
no longer be updated. */
    customer_shipping?: Shipping | undefined;
    /** The customer’s tax exempt status. Until the invoice is finalized, this field will equal
TaxExempt. Once the invoice is finalized, this field will no
longer be updated. */
    customer_tax_exempt?: string | undefined;
    /** The customer’s tax ids. Until the invoice is finalized, this field will equal
TaxIds. Once the invoice is finalized, this field will no
longer be updated. */
    customer_tax_ids?: InvoiceCustomerTaxId[] | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    /** Tax rates applied to the invoice. */
    default_tax_rates?: TaxRate[] | undefined;
    description?: string | undefined;
    discount?: Discount | undefined;
    /** The date on which payment for this invoice is due. This value will be null for invoices
where billing=charge_automatically. */
    due_date?: string | undefined;
    ending_balance?: number | undefined;
    footer?: string | undefined;
    hosted_invoice_url?: string | undefined;
    invoice_pdf?: string | undefined;
    lines?: StripeListOfInvoiceLineItem | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    next_payment_attempt?: string | undefined;
    /** A unique, identifying string that appears on emails sent to the customer for this
invoice. */
    number?: string | undefined;
    paid: boolean;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    period_end: string;
    period_start: string;
    /** Total amount of all post-payment credit notes issued for this invoice. */
    post_payment_credit_notes_amount?: number | undefined;
    /** Total amount of all pre-payment credit notes issued for this invoice. */
    pre_payment_credit_notes_amount?: number | undefined;
    receipt_number?: string | undefined;
    starting_balance: number;
    statement_descriptor?: string | undefined;
    status?: string | undefined;
    status_transitions?: InvoiceStatusTransitions | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
    subscription_proration_date: string;
    subtotal: number;
    tax?: number | undefined;
    tax_percent?: number | undefined;
    /** If BillingReason is set to subscription_threshold this
returns more information on which threshold rules triggered the invoice. */
    threshold_reason?: InvoiceThresholdReason | undefined;
    /** The tax amounts which apply to this invoice. */
    total_tax_amounts?: InvoiceTaxAmount[] | undefined;
    transfer_data?: InvoiceTransferData | undefined;
    total: number;
    webhooks_delivered_at?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfCharge {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Charge | undefined;
}

export interface StripeEntityOfCharge extends StripeEntity {
}

export interface Charge extends StripeEntityOfCharge {
    id?: string | undefined;
    object?: string | undefined;
    /** A positive integer in the smallest currency unit (e.g., 100 cents to charge $1.00 or 100 to charge ¥100, a 0-decimal currency) representing how much to charge. The minimum amount is $0.50 US or equivalent in charge currency. */
    amount: number;
    /** Amount in cents refunded (can be less than the amount attribute on the charge if a partial refund was issued). */
    amount_refunded: number;
    application?: ExpandableFieldOfApplication | undefined;
    application_fee?: ExpandableFieldOfApplicationFee | undefined;
    /** The amount of the application application fee (if any) for the charge. See the Connect documentation for details. */
    application_fee_amount?: number | undefined;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    /** Billing details of the payment method used in the payment. */
    billing_details?: BillingDetails | undefined;
    /** If the charge was created without capturing, this boolean represents whether or not it is still uncaptured or has since been captured. */
    captured?: boolean | undefined;
    created: string;
    /** Three-letter ISO currency code representing the currency in which the charge was made. */
    currency?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    description?: string | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
    dispute?: ExpandableFieldOfDispute | undefined;
    /** Error code explaining reason for charge failure if available (see the errors section for a list of codes). */
    failure_code?: string | undefined;
    /** Message to user further explaining reason for charge failure if available. */
    failure_message?: string | undefined;
    /** Hash with information on fraud assessments for the charge. Assessments reported by you have the key user_report and, if set, possible values of safe and fraudulent. Assessments from Stripe have the key stripe_report and, if set, the value fraudulent. */
    fraud_details?: { [key: string]: string; } | undefined;
    invoice?: ExpandableFieldOfInvoice | undefined;
    livemode: boolean;
    /** A set of key/value pairs that you can attach to a charge object. It can be useful for storing additional information about the charge in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    on_behalf_of?: ExpandableFieldOfAccount | undefined;
    order?: ExpandableFieldOfOrder | undefined;
    /** Details about the level III data associated with the Charge.
This is a gated property and most integrations can not access it. */
    level3?: ChargeLevel3 | undefined;
    /** Details about whether the payment was accepted, and why. */
    outcome?: Outcome | undefined;
    /** true if the charge succeeded, or was successfully authorized for later capture. */
    paid: boolean;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    /** ID of the PaymentMethod associated with this charge. */
    payment_method?: string | undefined;
    /** Transaction-specific details of the payment method used in the payment. */
    payment_method_details?: ChargePaymentMethodDetails | undefined;
    /** This is the email address that the receipt for this charge was sent to. */
    receipt_email?: string | undefined;
    /** This is the transaction number that appears on email receipts sent for this charge. */
    receipt_number?: string | undefined;
    /** This is the URL to view the receipt for this charge. The receipt is kept up-to-date to
the latest state of the charge, including any refunds. If the charge is for an Invoice,
the receipt will be stylized as an Invoice receipt. */
    receipt_url?: string | undefined;
    /** Whether or not the charge has been fully refunded. If the charge is only partially
refunded, this attribute will still be false. */
    refunded: boolean;
    /** A list of refunds that have been applied to the charge. */
    refunds?: StripeListOfRefund | undefined;
    review?: ExpandableFieldOfReview | undefined;
    /** Shipping information for the charge. */
    shipping?: Shipping | undefined;
    /** For most Stripe users, the source of every charge is a credit or debit card. This hash is then the card object describing that card. */
    source?: IPaymentSource | undefined;
    source_transfer?: ExpandableFieldOfTransfer | undefined;
    /** Extra information about a charge. This will appear on your customer’s credit card statement. */
    statement_descriptor?: string | undefined;
    /** Provides information about the charge that customers see on their statements.
Concatenated with the prefix (shortened descriptor) or statement descriptor that’s set
on the account to form the complete statement descriptor. Maximum 22 characters for the
concatenated descriptor. */
    statement_descriptor_suffix?: string | undefined;
    /** The status of the payment is either succeeded, pending, or failed */
    status?: string | undefined;
    transfer?: ExpandableFieldOfTransfer | undefined;
    transfer_data?: ChargeTransferData | undefined;
    /** A string that identifies this transaction as part of a group. See the Connect documentation for details. */
    transfer_group?: string | undefined;
    authorization_code?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfApplication {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Application | undefined;
}

export interface StripeEntityOfApplication extends StripeEntity {
}

export interface Application extends StripeEntityOfApplication {
    id?: string | undefined;
    object?: string | undefined;
    name?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfApplicationFee {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: ApplicationFee | undefined;
}

export interface StripeEntityOfApplicationFee extends StripeEntity {
}

export interface ApplicationFee extends StripeEntityOfApplicationFee {
    id?: string | undefined;
    object?: string | undefined;
    account?: ExpandableFieldOfAccount | undefined;
    amount: number;
    amount_refunded: number;
    application?: ExpandableFieldOfApplication | undefined;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created: string;
    currency?: string | undefined;
    livemode: boolean;
    originating_transaction?: ExpandableFieldOfCharge | undefined;
    refunded: boolean;
    refunds?: StripeListOfApplicationFeeRefund | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfAccount {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Account | undefined;
}

export interface StripeEntityOfAccount extends StripeEntity {
}

export interface Account extends StripeEntityOfAccount {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** Optional information related to the business. */
    business_profile?: AccountBusinessProfile | undefined;
    /** The business type. Can be company or individual. */
    business_type?: string | undefined;
    /** A hash containing the set of capabilities that was requested for this account and their
associated states. */
    capabilities?: AccountCapabilities | undefined;
    /** Whether the account can create live charges. */
    charges_enabled: boolean;
    /** Information about the company or business. This field is null unless
business_type is set to company. */
    company?: AccountCompany | undefined;
    /** The account’s country. */
    country?: string | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created: string;
    /** Three-letter ISO currency code representing the default currency for the account. This
must be a currency that Stripe supports in the account’s country. */
    default_currency?: string | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    /** Whether account details have been submitted. Standard accounts cannot receive payouts
before this is true. */
    details_submitted: boolean;
    /** The primary user’s email address. */
    email?: string | undefined;
    /** External accounts (bank accounts and debit cards) currently attached to this account. */
    external_accounts?: StripeListOfIExternalAccount | undefined;
    /** Information about the person represented by the account. This field is null unless
business_type is set to individual. */
    individual?: Person | undefined;
    /** Set of key-value pairs that you can attach to an object. This can be useful for storing
additional information about the object in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** Whether Stripe can send payouts to this account. */
    payouts_enabled: boolean;
    /** Information about the requirements for the account, including what information needs to
be collected, and by when. */
    requirements?: AccountRequirements | undefined;
    /** Account options for customizing how the account functions within Stripe. */
    settings?: AccountSettings | undefined;
    /** Details on the acceptance of the Stripe Services Agreement */
    tos_acceptance?: AccountTosAcceptance | undefined;
    /** The Stripe account type. Can be standard, express, or
custom. */
    type?: string | undefined;
}

export interface StripeEntityOfAccountBusinessProfile extends StripeEntity {
}

export interface AccountBusinessProfile extends StripeEntityOfAccountBusinessProfile {
    /** The merchant category code for the account. MCCs are used to classify businesses based
on the goods or services they provide. */
    mcc?: string | undefined;
    /** The customer-facing business name. */
    name?: string | undefined;
    /** Internal-only description of the product sold or service provided by the business. It’s
used by Stripe for risk and underwriting purposes. */
    product_description?: string | undefined;
    /** A publicly available mailing address for sending support issues to. */
    support_address?: Address2 | undefined;
    /** A publicly available email address for sending support issues to. */
    support_email?: string | undefined;
    /** A publicly available phone number to call with support issues. */
    support_phone?: string | undefined;
    /** A publicly available website for handling support issues. */
    support_url?: string | undefined;
    /** The business’s publicly available website. */
    url?: string | undefined;
}

export interface StripeEntityOfAccountCapabilities extends StripeEntity {
}

export interface AccountCapabilities extends StripeEntityOfAccountCapabilities {
    /** The status of the card payments capability of the account, or whether the account can
directly process credit and debit card charges. */
    card_payments?: string | undefined;
    /** The status of the legacy payments capability of the account. */
    legacy_payments?: string | undefined;
    /** The status of the transfers capability of the account, or whether your platform can
transfer funds to the account. */
    transfers?: string | undefined;
}

export interface StripeEntityOfAccountCompany extends StripeEntity {
}

export interface AccountCompany extends StripeEntityOfAccountCompany {
    /** The company’s primary address. */
    address?: Address2 | undefined;
    /** The Kana variation of the company’s primary address (Japan only). */
    address_kana?: AddressJapan | undefined;
    /** The Kanji variation of the company’s primary address (Japan only). */
    address_kanji?: AddressJapan | undefined;
    /** Whether information was collected from the company’s directors. */
    directors_provided: boolean;
    /** The company’s legal name. */
    name?: string | undefined;
    /** The Kana variation of the company’s legal name Japan only). */
    name_kana?: string | undefined;
    /** The Kanji variation of the company’s legal name (Japan only). */
    name_kanji?: string | undefined;
    /** Whether the company’s owners have been provided. */
    owners_provided: boolean;
    /** The company’s phone number (used for verification). */
    phone?: string | undefined;
    /** Whether the company’s business ID number was provided. */
    tax_id_provided: boolean;
    /** The jurisdiction in which the tax_id is registered (Germany-based
companies only). */
    tax_id_registrar?: string | undefined;
    /** Whether the company’s business VAT number was provided. */
    vat_id_provided: boolean;
    /** Information on the verification state of the company. */
    verification?: AccountCompanyVerification | undefined;
}

export interface AddressJapan extends Address2 {
    town?: string | undefined;
}

export interface StripeEntityOfAccountCompanyVerification extends StripeEntity {
}

export interface AccountCompanyVerification extends StripeEntityOfAccountCompanyVerification {
    /** A document for the company. */
    document?: AccountCompanyVerificationDocument | undefined;
}

export interface StripeEntityOfAccountCompanyVerificationDocument extends StripeEntity {
}

export interface AccountCompanyVerificationDocument extends StripeEntityOfAccountCompanyVerificationDocument {
    back?: ExpandableFieldOfFile | undefined;
    /** A user-displayable string describing the verification state of this document. */
    details?: string | undefined;
    /** A machine-readable code specifying the verification state for this document. One of
document_corrupt, document_failed_copy, document_not_readable,
document_not_uploaded, document_failed_other, document_fraudulent,
document_invalid, document_manipulated, document_too_large,
or document_failed_test_mode. */
    details_code?: string | undefined;
    front?: ExpandableFieldOfFile | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfFile {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: File | undefined;
}

export interface StripeEntityOfFile extends StripeEntity {
}

export interface File extends StripeEntityOfFile {
    id?: string | undefined;
    object?: string | undefined;
    created: string;
    filename?: string | undefined;
    links?: StripeListOfFileLink | undefined;
    purpose?: string | undefined;
    size: number;
    title?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfFileLink extends StripeEntity {
}

export interface StripeListOfFileLink extends StripeEntityOfStripeListOfFileLink {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: FileLink[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfFileLink extends StripeEntity {
}

export interface FileLink extends StripeEntityOfFileLink {
    id?: string | undefined;
    object?: string | undefined;
    /** Time at which the object was created. */
    created: string;
    /** Whether this link is already expired. */
    expired: boolean;
    /** Time at which the link expires. */
    expires_at?: string | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    file?: ExpandableFieldOfFile | undefined;
    /** Set of key-value pairs that you can attach to an object. This can be useful for storing
additional information about the object in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** The publicly accessible URL to download the file. */
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfIExternalAccount extends StripeEntity {
}

export interface StripeListOfIExternalAccount extends StripeEntityOfStripeListOfIExternalAccount {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: IExternalAccount[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

/** Resources that implement this interface can be used as external accounts, i.e. they can be attached to a Stripe account to receive payouts. Possible concrete classes: */
export interface IExternalAccount {
    account?: Account | undefined;
    accountId?: string | undefined;
}

export interface StripeEntityOfPerson extends StripeEntity {
}

export interface Person extends StripeEntityOfPerson {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** The account the person is associated with. */
    account?: string | undefined;
    /** The person’s address. */
    address?: Address2 | undefined;
    /** The Kana variation of the person’s address (Japan only). */
    address_kana?: AddressJapan | undefined;
    /** The Kanji variation of the person’s address (Japan only). */
    address_kanji?: AddressJapan | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created: string;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    /** The person’s date of birth. */
    dob?: Dob | undefined;
    /** The person’s email address. */
    email?: string | undefined;
    /** The person’s first name. */
    first_name?: string | undefined;
    /** The Kana variation of the person’s first name (Japan only). */
    first_name_kana?: string | undefined;
    /** The Kanji variation of the person’s first name (Japan only). */
    first_name_kanji?: string | undefined;
    /** The person’s gender (International regulations require either “male” or “female”). */
    gender?: string | undefined;
    /** Whether the person’s id_number was provided. */
    id_number_provided: boolean;
    /** The person’s last name. */
    last_name?: string | undefined;
    /** The Kana variation of the person’s last name (Japan only). */
    last_name_kana?: string | undefined;
    /** The Kanji variation of the person’s last name (Japan only). */
    last_name_kanji?: string | undefined;
    /** The person’s maiden name. */
    maiden_name?: string | undefined;
    /** Set of key-value pairs that you can attach to an object. This can be useful for storing
additional information about the object in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** The person’s phone number. */
    phone?: string | undefined;
    /** Describes the person’s relationship to the account. */
    relationship?: PersonRelationship | undefined;
    /** Information about the requirements for this person, including what information needs to
be collected, and by when. */
    requirements?: PersonRequirements | undefined;
    /** Whether the last 4 digits of this person’s SSN have been provided. */
    ssn_last_4_provided: boolean;
    /** The persons’s verification status. */
    verification?: PersonVerification | undefined;
}

export interface StripeEntityOfDob extends StripeEntity {
}

export interface Dob extends StripeEntityOfDob {
    /** The day of birth, between 1 and 31. */
    day?: number | undefined;
    /** The month of birth, between 1 and 12. */
    month?: number | undefined;
    /** The four-digit year of birth. */
    year?: number | undefined;
}

export interface StripeEntityOfPersonRelationship extends StripeEntity {
}

export interface PersonRelationship extends StripeEntityOfPersonRelationship {
    /** Whether the person opened the account. This person provides information about
themselves, and general information about the account. */
    account_opener: boolean;
    /** Whether the person is a director of the account’s legal entity.. */
    director: boolean;
    /** Whether the person has significant responsibility to control, manage, or direct the
organization. */
    executive: boolean;
    /** Whether the person is an owner of the account’s legal entity.. */
    owner: boolean;
    /** The percent owned by the person of the account’s legal entity. */
    percent_ownership?: number | undefined;
    /** The person’s title (e.g., CEO, Support Engineer). */
    title?: string | undefined;
}

export interface StripeEntityOfPersonRequirements extends StripeEntity {
}

export interface PersonRequirements extends StripeEntityOfPersonRequirements {
    /** Fields that need to be collected to keep the person’s account enabled. If not collected
by the account’s current_deadline, these fields are moved to
past_due and the account is disabled. */
    currently_due?: string[] | undefined;
    /** Fields that need to be collected assuming all volume thresholds are reached. As fields
are needed, they are moved to currently_due and the account’s
current_deadline is set. */
    eventually_due?: string[] | undefined;
    /** Fields that weren’t collected by the account’s current_deadline. These
fields need to be collected to enable payouts for the person’s account. */
    past_due?: string[] | undefined;
    /** Additional fields that may be required depending on the results of verification or
review for provided requirements. If any of these fields become required, they appear in
CurrentlyDue or PastDue. */
    pending_verification?: string[] | undefined;
}

export interface StripeEntityOfPersonVerification extends StripeEntity {
}

export interface PersonVerification extends StripeEntityOfPersonVerification {
    /** A document showing address, either a passport, local ID card, or utility bill from a
well-known utility company. */
    additional_document?: PersonVerificationDocument | undefined;
    /** A user-displayable string describing the verification state for this person. For
example, if a document is uploaded and the picture is too fuzzy, this may say “Identity
document is too unclear to read”. */
    details?: string | undefined;
    /** A machine-readable code specifying the verification state for this person. One of
document_name_mismatch, failed_keyed_identity, or
failed_other. */
    details_code?: string | undefined;
    /** An identifying document for this individual, either a passport or local ID card. */
    document?: PersonVerificationDocument | undefined;
    /** The state of verification for this person. Possible values are unverified,
pending, or verified. */
    status?: string | undefined;
}

export interface StripeEntityOfPersonVerificationDocument extends StripeEntity {
}

export interface PersonVerificationDocument extends StripeEntityOfPersonVerificationDocument {
    back?: ExpandableFieldOfFile | undefined;
    /** A user-displayable string describing the verification state of this document. For
example, if a document is uploaded and the picture is too fuzzy, this may say “Identity
document is too unclear to read”. */
    details?: string | undefined;
    /** A machine-readable code specifying the verification state for this document. */
    details_code?: string | undefined;
    front?: ExpandableFieldOfFile | undefined;
}

export interface StripeEntityOfAccountRequirements extends StripeEntity {
}

export interface AccountRequirements extends StripeEntityOfAccountRequirements {
    /** The date the fields in currently_due must be collected by to keep payouts
enabled for the account. These fields might block payouts sooner if the next threshold
is reached before these fields are collected. */
    current_deadline?: string | undefined;
    /** The fields that need to be collected to keep the account enabled. If not collected by
the current_deadline, these fields are moved to past_due and
the account is disabled. */
    currently_due?: string[] | undefined;
    /** If the account is disabled, this string describes why the account can’t create charges
or receive payouts. */
    disabled_reason?: string | undefined;
    /** The fields that need to be collected assuming all volume thresholds are reached. As
fields are needed, they are moved to currently_due and the
current_deadline is set. */
    eventually_due?: string[] | undefined;
    /** The fields that weren’t collected by the currently_due. These fields need
to be collected to enable payouts for the account. */
    past_due?: string[] | undefined;
    /** Additional fields that may be required depending on the results of verification or
review for provided requirements. If any of these fields become required, they appear in
CurrentlyDue or PastDue. */
    pending_verification?: string[] | undefined;
}

export interface StripeEntityOfAccountSettings extends StripeEntity {
}

export interface AccountSettings extends StripeEntityOfAccountSettings {
    /** Settings used to apply the account’s branding to email receipts, invoices, Checkout,
and other products. */
    branding?: AccountSettingsBranding | undefined;
    /** Settings specific to card charging on the account. */
    card_payments?: AccountSettingsCardPayments | undefined;
    /** Settings used to configure the account within the Stripe dashboard. */
    dashboard?: AccountSettingsDashboard | undefined;
    /** Settings that apply across payment methods for charging on the account. */
    payments?: AccountSettingsPayments | undefined;
    /** Settings specific to the account’s payouts. */
    payouts?: AccountSettingsPayouts | undefined;
}

export interface StripeEntityOfAccountSettingsBranding extends StripeEntity {
}

export interface AccountSettingsBranding extends StripeEntityOfAccountSettingsBranding {
    icon?: ExpandableFieldOfFile | undefined;
    logo?: ExpandableFieldOfFile | undefined;
    /** A CSS hex color value representing the primary branding color for this account. */
    primary_color?: string | undefined;
}

export interface StripeEntityOfAccountSettingsCardPayments extends StripeEntity {
}

export interface AccountSettingsCardPayments extends StripeEntityOfAccountSettingsCardPayments {
    /** Automatically declines certain charge types regardless of whether the card issuer
accepted or declined the charge. */
    decline_on?: AccountSettingsDeclineOn | undefined;
    /** The default text that appears on credit card statements when a charge is made. This
field prefixes any dynamic statement_descriptor specified on the charge.
statement_descriptor_prefix is useful for maximizing descriptor space for
the dynamic portion. */
    statement_descriptor_prefix?: string | undefined;
}

export interface StripeEntityOfAccountSettingsDeclineOn extends StripeEntity {
}

export interface AccountSettingsDeclineOn extends StripeEntityOfAccountSettingsDeclineOn {
    /** Whether Stripe automatically declines charges with an incorrect ZIP or postal code.
This setting only applies when a ZIP or postal code is provided and they fail bank
verification. */
    avs_failure: boolean;
    /** Whether Stripe automatically declines charges with an incorrect CVC. This setting only
applies when a CVC is provided and it fails bank verification. */
    cvc_failure: boolean;
}

export interface StripeEntityOfAccountSettingsDashboard extends StripeEntity {
}

export interface AccountSettingsDashboard extends StripeEntityOfAccountSettingsDashboard {
    /** The display name for this account. This is used on the Stripe Dashboard to
differentiate between accounts. */
    display_name?: string | undefined;
    /** The timezone used in the Stripe Dashboard for this account. */
    timezone?: string | undefined;
}

export interface StripeEntityOfAccountSettingsPayments extends StripeEntity {
}

export interface AccountSettingsPayments extends StripeEntityOfAccountSettingsPayments {
    /** The default text that appears on credit card statements when a charge is made. This
field prefixes any dynamic statement_descriptor specified on the charge. */
    statement_descriptor?: string | undefined;
    /** The Kana variation of the default text that appears on credit card statements when a
charge is made (Japan only). */
    statement_descriptor_kana?: string | undefined;
    /** The Kanji variation of the default text that appears on credit card statements when a
charge is made (Japan only). */
    statement_descriptor_kanji?: string | undefined;
}

export interface StripeEntityOfAccountSettingsPayouts extends StripeEntity {
}

export interface AccountSettingsPayouts extends StripeEntityOfAccountSettingsPayouts {
    /** A Boolean indicating if Stripe should try to reclaim negative balances from an attached
bank account. */
    debit_negative_balances: boolean;
    /** Details on when funds from charges are available, and when they are paid out to an
external account. */
    schedule?: AccountSettingsPayoutsSchedule | undefined;
    /** The text that appears on the bank account statement for payouts. If not set, this
efaults to the platform’s bank descriptor as set in the Dashboard. */
    statement_descriptor?: string | undefined;
}

export interface StripeEntityOfAccountSettingsPayoutsSchedule extends StripeEntity {
}

export interface AccountSettingsPayoutsSchedule extends StripeEntityOfAccountSettingsPayoutsSchedule {
    /** The number of days charges for the account will be held before being paid out. */
    delay_days: number;
    /** How frequently funds will be paid out. One of manual (payouts only created
via API call), daily, weekly, or monthly. */
    interval?: string | undefined;
    /** The day of the month funds will be paid out. Only shown if interval is
monthly. Payouts scheduled between the 29th and 31st of the month are sent
on the last day of shorter months. */
    monthly_anchor: number;
    /** The day of the week funds will be paid out, of the style ‘monday’, ‘tuesday’, etc.
Only shown if interval is weekly. */
    weekly_anchor?: string | undefined;
}

export interface StripeEntityOfAccountTosAcceptance extends StripeEntity {
}

export interface AccountTosAcceptance extends StripeEntityOfAccountTosAcceptance {
    /** The Unix timestamp marking when the Stripe Services Agreement was accepted by the
account representative. */
    date?: string | undefined;
    /** The IP address from which the Stripe Services Agreement was accepted by the account
representative. */
    ip?: string | undefined;
    /** The user agent of the browser from which the Stripe Services Agreement was accepted by
the account representative. */
    user_agent?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfBalanceTransaction {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: BalanceTransaction | undefined;
}

export interface StripeEntityOfBalanceTransaction extends StripeEntity {
}

export interface BalanceTransaction extends StripeEntityOfBalanceTransaction {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    available_on: string;
    created: string;
    currency?: string | undefined;
    description?: string | undefined;
    exchange_rate?: number | undefined;
    fee: number;
    fee_details?: Fee[] | undefined;
    net: number;
    source?: ExpandableFieldOfIBalanceTransactionSource | undefined;
    status?: string | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfFee extends StripeEntity {
}

export interface Fee extends StripeEntityOfFee {
    amount: number;
    application?: string | undefined;
    currency?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfIBalanceTransactionSource {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: IBalanceTransactionSource | undefined;
}

/** Resources that implement this interface can appear as sources in balance transactions. Possible concrete classes: */
export interface IBalanceTransactionSource {
}

export interface StripeEntityOfStripeListOfApplicationFeeRefund extends StripeEntity {
}

export interface StripeListOfApplicationFeeRefund extends StripeEntityOfStripeListOfApplicationFeeRefund {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: ApplicationFeeRefund[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfApplicationFeeRefund extends StripeEntity {
}

export interface ApplicationFeeRefund extends StripeEntityOfApplicationFeeRefund {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    created: string;
    currency?: string | undefined;
    fee?: ExpandableFieldOfApplicationFee | undefined;
    metadata?: { [key: string]: string; } | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfDispute {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Dispute | undefined;
}

export interface StripeEntityOfDispute extends StripeEntity {
}

export interface Dispute extends StripeEntityOfDispute {
    id?: string | undefined;
    object?: string | undefined;
    amount?: number | undefined;
    balance_transactions?: BalanceTransaction[] | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created?: string | undefined;
    currency?: string | undefined;
    evidence?: Evidence | undefined;
    evidence_details?: EvidenceDetails | undefined;
    is_charge_refundable: boolean;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    reason?: string | undefined;
    status?: string | undefined;
}

export interface StripeEntityOfEvidence extends StripeEntity {
}

export interface Evidence extends StripeEntityOfEvidence {
    access_activity_log?: string | undefined;
    billing_address?: string | undefined;
    cancellation_policy?: ExpandableFieldOfFile | undefined;
    cancellation_policy_disclosure?: string | undefined;
    cancellation_rebuttal?: string | undefined;
    customer_communication?: ExpandableFieldOfFile | undefined;
    customer_email_address?: string | undefined;
    customer_name?: string | undefined;
    customer_purchase_ip?: string | undefined;
    customer_signature?: ExpandableFieldOfFile | undefined;
    duplicate_charge_documentation?: ExpandableFieldOfFile | undefined;
    duplicate_charge_explanation?: string | undefined;
    duplicate_charge_id?: string | undefined;
    product_description?: string | undefined;
    receipt?: ExpandableFieldOfFile | undefined;
    refund_policy?: ExpandableFieldOfFile | undefined;
    refund_policy_disclosure?: string | undefined;
    refund_refusal_explanation?: string | undefined;
    service_date?: string | undefined;
    service_documentation?: ExpandableFieldOfFile | undefined;
    shipping_address?: string | undefined;
    shipping_carrier?: string | undefined;
    shipping_date?: string | undefined;
    shipping_documentation?: ExpandableFieldOfFile | undefined;
    shipping_tracking_number?: string | undefined;
    uncategorized_file?: ExpandableFieldOfFile | undefined;
    uncategorized_text?: string | undefined;
}

export interface StripeEntityOfEvidenceDetails extends StripeEntity {
}

export interface EvidenceDetails extends StripeEntityOfEvidenceDetails {
    due_by?: string | undefined;
    has_evidence: boolean;
    past_due: boolean;
    submission_count: number;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfOrder {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Order | undefined;
}

export interface StripeEntityOfOrder extends StripeEntity {
}

export interface Order extends StripeEntityOfOrder {
    id?: string | undefined;
    object?: string | undefined;
    /** A positive integer in the smallest currency unit (that is, 100 cents for $1.00, or 1 for ¥1, Japanese Yen being a 0-decimal currency) representing the total amount for the order. */
    amount: number;
    amount_returned?: number | undefined;
    /** ID of the Connect Application that created the order. */
    application?: string | undefined;
    application_fee?: number | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    /** Time at which the object was created. */
    created: string;
    /** 3-letter ISO code representing the currency in which the order was made. */
    currency?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** The email address of the customer placing the order. */
    email?: string | undefined;
    external_coupon_code?: string | undefined;
    /** List of items constituting the order. */
    items?: OrderItem[] | undefined;
    livemode: boolean;
    /** A set of key/value pairs that you can attach to an order object. It can be useful for storing additional information about the order in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    returns?: StripeListOfOrderReturn | undefined;
    /** The shipping method that is currently selected for this order, if any. If present, it is equal to one of the ids of shipping methods in the shipping_methods array. At order creation time, if there are multiple shipping methods, Stripe will automatically selected the first method. */
    selected_shipping_method?: string | undefined;
    /** The shipping address for the order. Present if the order is for goods to be shipped. */
    shipping?: Shipping | undefined;
    /** A list of supported shipping methods for this order. The desired shipping method can be specified either by updating the order, or when paying it. */
    shipping_methods?: ShippingMethod[] | undefined;
    /** Current order status. One of created, paid, canceled, fulfilled, or returned. */
    status?: string | undefined;
    /** The timestamps at which the order status was updated. */
    status_transitions?: StatusTransitions | undefined;
    updated: string;
    /** The merchant’s order ID if it is different from the Stripe order ID. */
    upstream_id?: string | undefined;
}

export interface StripeEntityOfOrderItem extends StripeEntity {
}

export interface OrderItem extends StripeEntityOfOrderItem {
    object?: string | undefined;
    /** A positive integer in the smallest currency unit (that is, 100 cents for $1.00, or 1 for ¥1, Japanese Yen being a 0-decimal currency) representing the total amount for the line item. */
    amount: number;
    /** Three-letter ISO currency code, in lowercase. Must be a supported currency. */
    currency?: string | undefined;
    /** Description of the line item, meant to be displayable to the user (e.g., "Express shipping"). */
    description?: string | undefined;
    parent?: ExpandableFieldOfSku | undefined;
    /** A positive integer representing the number of instances of parent that are included in this order item. Applicable/present only if type is sku. */
    quantity?: number | undefined;
    /** The type of line item. One of sku, tax, shipping, or discount. */
    type?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfSku {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Sku | undefined;
}

export interface StripeEntityOfSku extends StripeEntity {
}

export interface Sku extends StripeEntityOfSku {
    id?: string | undefined;
    object?: string | undefined;
    /** Whether or not the SKU is available for purchase. */
    active: boolean;
    /** A dictionary of attributes and values for the attributes defined by the product. If, for example, a product’s attributes are ["size", "gender"], a valid SKU has the following dictionary of attributes: {"size": "Medium", "gender": "Unisex"}. */
    attributes?: { [key: string]: string; } | undefined;
    /** Time at which the object was created. */
    created: string;
    /** Three-letter ISO currency code, in lowercase. Must be a supported currency. */
    currency?: string | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    /** The URL of an image for this SKU, meant to be displayable to the customer. */
    image?: string | undefined;
    /** Description of the SKU’s inventory. */
    inventory?: Inventory | undefined;
    /** Flag indicating whether the object exists in live mode or test mode. */
    livemode: boolean;
    /** Set of key/value pairs that you can attach to an object. It can be useful for storing additional information about the object in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** The dimensions of this SKU for shipping purposes. */
    package_dimensions?: PackageDimensions | undefined;
    /** The cost of the item as a positive integer in the smallest currency unit (that is, 100 cents to charge $1.00, or 100 to charge ¥100, Japanese Yen being a 0-decimal currency). */
    price: number;
    product?: ExpandableFieldOfProduct | undefined;
    updated: string;
}

export interface StripeEntityOfInventory extends StripeEntity {
}

export interface Inventory extends StripeEntityOfInventory {
    quantity?: number | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export interface StripeEntityOfStripeListOfOrderReturn extends StripeEntity {
}

export interface StripeListOfOrderReturn extends StripeEntityOfStripeListOfOrderReturn {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: OrderReturn[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfOrderReturn extends StripeEntity {
}

export interface OrderReturn extends StripeEntityOfOrderReturn {
    id?: string | undefined;
    object?: string | undefined;
    /** A positive integer in the smallest currency unit (that is, 100 cents for $1.00, or 1 for ¥1, Japanese Yen being a 0-decimal currency) representing the total amount for the returned line item. */
    amount: number;
    created: string;
    /** 3-letter ISO code representing the currency of the return. */
    currency?: string | undefined;
    /** The items included in this order return. */
    items?: OrderItem[] | undefined;
    livemode: boolean;
    order?: ExpandableFieldOfOrder | undefined;
    refund?: ExpandableFieldOfRefund | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfRefund {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Refund | undefined;
}

export interface StripeEntityOfRefund extends StripeEntity {
}

export interface Refund extends StripeEntityOfRefund {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created: string;
    currency?: string | undefined;
    description?: string | undefined;
    failure_balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    failure_reason?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    reason?: string | undefined;
    receipt_number?: string | undefined;
    source_transfer_reversal?: ExpandableFieldOfTransferReversal | undefined;
    status?: string | undefined;
    transfer_reversal?: ExpandableFieldOfTransferReversal | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfTransferReversal {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: TransferReversal | undefined;
}

export interface StripeEntityOfTransferReversal extends StripeEntity {
}

export interface TransferReversal extends StripeEntityOfTransferReversal {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    created: string;
    currency?: string | undefined;
    destination_payment_refund?: ExpandableFieldOfRefund | undefined;
    metadata?: { [key: string]: string; } | undefined;
    source_refund?: ExpandableFieldOfRefund | undefined;
    transfer?: ExpandableFieldOfTransfer | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfTransfer {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Transfer | undefined;
}

export interface StripeEntityOfTransfer extends StripeEntity {
}

export interface Transfer extends StripeEntityOfTransfer {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    amount_reversed: number;
    balance_transaction?: ExpandableFieldOfBalanceTransaction | undefined;
    created: string;
    currency?: string | undefined;
    description?: string | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
    destination_payment?: ExpandableFieldOfCharge | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    reversals?: StripeListOfTransferReversal | undefined;
    reversed: boolean;
    source_transaction?: ExpandableFieldOfCharge | undefined;
    source_type?: string | undefined;
    transfer_group?: string | undefined;
}

export interface StripeEntityOfStripeListOfTransferReversal extends StripeEntity {
}

export interface StripeListOfTransferReversal extends StripeEntityOfStripeListOfTransferReversal {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: TransferReversal[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfShipping extends StripeEntity {
}

export interface Shipping extends StripeEntityOfShipping {
    address?: Address2 | undefined;
    carrier?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    tracking_number?: string | undefined;
}

export interface StripeEntityOfShippingMethod extends StripeEntity {
}

export interface ShippingMethod extends StripeEntityOfShippingMethod {
    id?: string | undefined;
    /** A positive integer in the smallest currency unit (that is, 100 cents for $1.00, or 1 for ¥1, Japanese Yen being a 0-decimal currency) representing the total amount for the line item. */
    amount: number;
    /** 3-letter ISO code representing the currency of the line item. */
    currency?: string | undefined;
    /** The estimated delivery date for the given shipping method. Can be either a specific date or a range. */
    delivery_estimate?: DeliveryEstimate | undefined;
    /** Description of the line item, meant to be displayable to the user (e.g., "Express shipping"). */
    description?: string | undefined;
}

export interface StripeEntityOfDeliveryEstimate extends StripeEntity {
}

export interface DeliveryEstimate extends StripeEntityOfDeliveryEstimate {
    /** If type is "exact", date will be the expected delivery date in the format YYYY-MM-DD. */
    date?: string | undefined;
    /** If type is "range", earliest will be be the earliest delivery date in the format YYYY-MM-DD. */
    earliest?: string | undefined;
    /** If type is "range", latest will be the latest delivery date in the format YYYY-MM-DD */
    latest?: string | undefined;
    /** The type of estimate. Must be either "range" or "exact". */
    type?: string | undefined;
}

export interface StripeEntityOfStatusTransitions extends StripeEntity {
}

export interface StatusTransitions extends StripeEntityOfStatusTransitions {
    canceled?: string | undefined;
    fulfiled?: string | undefined;
    paid?: string | undefined;
    returned?: string | undefined;
}

export interface StripeEntityOfChargeLevel3 extends StripeEntity {
}

export interface ChargeLevel3 extends StripeEntityOfChargeLevel3 {
    customer_reference?: string | undefined;
    line_items?: ChargeLevel3LineItem[] | undefined;
    merchant_reference?: string | undefined;
    shipping_address_zip?: string | undefined;
    shipping_from_zip?: string | undefined;
    shipping_amount: number;
}

export interface StripeEntityOfChargeLevel3LineItem extends StripeEntity {
}

export interface ChargeLevel3LineItem extends StripeEntityOfChargeLevel3LineItem {
    discount_amount?: number | undefined;
    product_code?: string | undefined;
    product_description?: string | undefined;
    quantity?: number | undefined;
    tax_amount?: number | undefined;
    unit_cost?: number | undefined;
}

export interface StripeEntityOfOutcome extends StripeEntity {
}

export interface Outcome extends StripeEntityOfOutcome {
    /** Possible values are approved_by_network, declined_by_network, not_sent_to_network, and reversed_after_approval. The value reversed_after_approval indicates the payment was blocked by Stripe after bank authorization, and may temporarily appear as “pending” on a cardholder’s statement. */
    network_status?: string | undefined;
    /** An enumerated value indicating a more detailed explanation of the outcome’s type. See understanding declines for details. */
    reason?: string | undefined;
    /** An enumerated value indicating a more detailed explanation of the outcome’s type. See understanding declines for details. */
    risk_level?: string | undefined;
    /** Stripe’s evaluation of the riskiness of the payment. Possible values for evaluated payments are between 0 and 100. */
    risk_score: number;
    rule?: ExpandableFieldOfOutcomeRule | undefined;
    /** A human-readable description of the outcome type and reason, designed for you (the recipient of the payment), not your customer. */
    seller_message?: string | undefined;
    /** Possible values are authorized, issuer_declined, blocked, and invalid. See understanding declines for details. */
    type?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfOutcomeRule {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: OutcomeRule | undefined;
}

export interface StripeEntityOfOutcomeRule extends StripeEntity {
}

export interface OutcomeRule extends StripeEntityOfOutcomeRule {
    id?: string | undefined;
    action?: string | undefined;
    predicate?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfPaymentIntent {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: PaymentIntent | undefined;
}

export interface StripeEntityOfPaymentIntent extends StripeEntity {
}

export interface PaymentIntent extends StripeEntityOfPaymentIntent {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** Amount intended to be collected by this PaymentIntent. */
    amount?: number | undefined;
    /** Amount that can be captured from this PaymentIntent. */
    amount_capturable?: number | undefined;
    /** Amount that was collected by this PaymentIntent. */
    amount_received?: number | undefined;
    application?: ExpandableFieldOfApplication | undefined;
    /** The amount of the application fee (if any) for the resulting payment. See the
PaymentIntents 
use case for connected accounts for details. */
    application_fee_amount?: number | undefined;
    /** Populated when status is canceled, this is the time at which the PaymentIntent
was canceled. Measured in seconds since the Unix epoch. */
    canceled_at?: string | undefined;
    /** Reason for cancellation of this PaymentIntent, either user-provided (duplicate,
fraudulent, requested_by_customer, or abandoned) or generated by
Stripe internally (failed_invoice, void_invoice, or automatic). */
    cancellation_reason?: string | undefined;
    /** One of automatic (default) or manual.
When the capture method is automatic, Stripe automatically captures funds when
the customer authorizes the payment.
Change the capture method to manual if you wish to 
separate authorization and capture for payment methods that support this. */
    capture_method?: string | undefined;
    /** Charges that were created by this PaymentIntent, if any. */
    charges?: StripeListOfCharge | undefined;
    /** The client secret of this PaymentIntent. Used for client-side retrieval using a
publishable key.
The client secret can be used to complete a payment from your frontend. It should not
be stored, logged, embedded in URLs, or exposed to anyone other than the customer. Make
sure that you have TLS enabled on any page that includes the client secret.
Please refer to our 
automatic confirmation quickstart guide to learn about how client_secret should be
handled. */
    client_secret?: string | undefined;
    /** One of automatic (default) or manual.
When the confirmation method is automatic, a PaymentIntent can be confirmed
using a publishable key. After next actions are handled, no additional confirmation is
required to complete the payment.
When the confirmation method is manual, all payment attempts must be made using
a secret key. The PaymentIntent returns to the requires_confirmation state after
handling next_actions, and requires your server to initiate each payment attempt with
an explicit confirmation. */
    confirmation_method?: string | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created?: string | undefined;
    /** Three-letter ISO currency code, in lowercase. Must be a supported currency. */
    currency?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** An arbitrary string attached to the object. Often useful for displaying to users. */
    description?: string | undefined;
    invoice?: ExpandableFieldOfInvoice | undefined;
    /** The payment error encountered in the previous PaymentIntent confirmation. */
    last_payment_error?: StripeError | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** A set of key/value pairs that you can attach to an order object. It can be useful for
storing additional information about the order in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** If present, this property tells you what actions you need to take in order for your
customer to fulfill a payment using the provided source. */
    next_action?: PaymentIntentNextAction | undefined;
    on_behalf_of?: ExpandableFieldOfAccount | undefined;
    payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    /** Payment-method-specific configuration for this PaymentIntent. */
    payment_method_options?: PaymentIntentPaymentMethodOptions | undefined;
    /** The list of payment method types (e.g. card) that this PaymentIntent is allowed to use. */
    payment_method_types?: string[] | undefined;
    /** Email address that the receipt for the resulting payment will be sent to. */
    receipt_email?: string | undefined;
    review?: ExpandableFieldOfReview | undefined;
    /** Indicates that you intend to make future payments with this PaymentIntent’s payment
method.
If present, the payment method used with this PaymentIntent can be attached to a
Customer, even after the transaction completes.
Use on_session if you intend to only reuse the payment method when your customer
is present in your checkout flow. Use off_session if your customer may or may
not be in your checkout flow.
Stripe uses this to dynamically optimize your payment flow and comply with regional
legislation and network rules. For example, if your customer is impacted by SCA, using
off_session will ensure that they are authenticated while processing this
PaymentIntent. You will then be able to make later off-session payments for this
customer. */
    setup_future_usage?: string | undefined;
    /** Shipping information for this PaymentIntent. */
    shipping?: Shipping | undefined;
    source?: ExpandableFieldOfIPaymentSource | undefined;
    /** Extra information about a PaymentIntent. This will appear on your customer’s statement
when this PaymentIntent succeeds in creating a charge */
    statement_descriptor?: string | undefined;
    /** Provides information about the charge that customers see on their statements.
Concatenated with the prefix (shortened descriptor) or statement descriptor that’s set
on the account to form the complete statement descriptor. Maximum 22 characters for the
concatenated descriptor. */
    statement_descriptor_suffix?: string | undefined;
    /** Status of this PaymentIntent, one of requires_payment_method,
requires_confirmation, requires_action, processing,
requires_capture, canceled, or succeeded. Read more about each
PaymentIntent status. */
    status?: string | undefined;
    /** The data with which to automatically create a Transfer when the payment is finalized.
See the PaymentIntents 
use case for connected accounts for details. */
    transfer_data?: PaymentIntentTransferData | undefined;
    /** A string that identifies the resulting payment as part of a group. See the
PaymentIntents 
use case for connected accounts for details. */
    transfer_group?: string | undefined;
    allowed_source_types?: string[] | undefined;
}

export interface StripeEntityOfStripeListOfCharge extends StripeEntity {
}

export interface StripeListOfCharge extends StripeEntityOfStripeListOfCharge {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: Charge[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfStripeError extends StripeEntity {
}

export interface StripeError extends StripeEntityOfStripeError {
    /** For card errors, the ID of the failed charge. */
    charge?: string | undefined;
    /** For some errors that could be handled programmatically, a short string indicating the
error code reported. */
    code?: string | undefined;
    /** For card errors resulting from a card issuer decline, a short string indicating the
card issuer's reason for the
decline */
    decline_code?: string | undefined;
    /** A URL to more information about the error
code reported. */
    doc_url?: string | undefined;
    /** A human-readable message providing more details about the error. For card errors, these
messages can be shown to your users. */
    message?: string | undefined;
    /** If the error is parameter-specific, the parameter related to the error. For example,
you can use this to display a message near the correct form field. */
    param?: string | undefined;
    /** The PaymentIntent object for errors returned on a request
involving a PaymentIntent. */
    payment_intent?: PaymentIntent | undefined;
    /** The PaymentMethod object for errors returned on a request
involving a PaymentMethod. */
    payment_method?: PaymentMethod | undefined;
    /** The SetupIntent object for errors returned on a request
involving a SetupIntent. */
    setup_intent?: SetupIntent | undefined;
    /** The source object for errors returned on a request involving a source. */
    source?: IPaymentSource | undefined;
    /** The type of error returned. One of api_connection_error, api_error,
authentication_error, card_error, idempotency_error,
invalid_request_error, or rate_limit_error */
    type?: string | undefined;
    error?: string | undefined;
    error_description?: string | undefined;
}

export interface StripeEntityOfSetupIntent extends StripeEntity {
}

export interface SetupIntent extends StripeEntityOfSetupIntent {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    application?: ExpandableFieldOfApplication | undefined;
    /** Reason for canceling this SetupIntent. Possible values are abandoned,
requested_by_customer, or duplicate. */
    cancellation_reason?: string | undefined;
    /** The client secret of this SetupIntent. Used for client-side retrieval using a
publishable key.

The client secret can be used to complete payment setup from your frontend. It should
not be stored, logged, embedded in URLs, or exposed to anyone other than the customer.
Make sure that you have TLS enabled on any page that includes the client secret. */
    client_secret?: string | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created?: string | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** An arbitrary string attached to the object. Often useful for displaying to users. */
    description?: string | undefined;
    /** The error encountered in the previous SetupIntent confirmation. */
    last_setup_error?: StripeError | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** A set of key/value pairs that you can attach to an order object. It can be useful for
storing additional information about the order in a structured format. */
    metadata?: { [key: string]: string; } | undefined;
    /** If present, this property tells you what actions you need to take in order for your
customer to continue payment setup. */
    next_action?: SetupIntentNextAction | undefined;
    on_behalf_of?: ExpandableFieldOfAccount | undefined;
    payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    /** Payment-method-specific configuration for this SetupIntent. */
    payment_method_options?: SetupIntentPaymentMethodOptions | undefined;
    /** The list of payment method types (e.g. card) that this SetupIntent is allowed to set up. */
    payment_method_types?: string[] | undefined;
    /** Status of this SetupIntent, one of requires_payment_method,
requires_confirmation, requires_action, processing,
canceled, or succeeded. */
    status?: string | undefined;
    /** Indicates how the payment method is intended to be used in the future. Use
on_session if you intend to only reuse the payment method when the customer is in
your checkout flow. Use off_session if your customer may or may not be in your
checkout flow. If not provided, this value defaults to off_session. */
    usage?: string | undefined;
}

export interface StripeEntityOfSetupIntentNextAction extends StripeEntity {
}

export interface SetupIntentNextAction extends StripeEntityOfSetupIntentNextAction {
    redirect_to_url?: SetupIntentNextActionRedirectToUrl | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfSetupIntentNextActionRedirectToUrl extends StripeEntity {
}

export interface SetupIntentNextActionRedirectToUrl extends StripeEntityOfSetupIntentNextActionRedirectToUrl {
    return_url?: string | undefined;
    url?: string | undefined;
}

export interface StripeEntityOfSetupIntentPaymentMethodOptions extends StripeEntity {
}

export interface SetupIntentPaymentMethodOptions extends StripeEntityOfSetupIntentPaymentMethodOptions {
    /** If the SetupIntent’s payment method types include card, this hash contains the
configurations that will be applied to each setup attempt of that type. */
    card?: SetupIntentPaymentMethodOptionsCard | undefined;
}

export interface StripeEntityOfSetupIntentPaymentMethodOptionsCard extends StripeEntity {
}

export interface SetupIntentPaymentMethodOptionsCard extends StripeEntityOfSetupIntentPaymentMethodOptionsCard {
    /** We strongly recommend that you rely on our SCA engine to automatically prompt your
customers for authentication based on risk level and other requirements. However, if
you wish to request authentication based on logic from your own fraud engine, provide
this option. Permitted values include: automatic, any, or
challenge_only. */
    request_three_d_secure?: string | undefined;
}

export interface StripeEntityOfPaymentIntentNextAction extends StripeEntity {
}

export interface PaymentIntentNextAction extends StripeEntityOfPaymentIntentNextAction {
    /** Contains instructions for authenticating a payment by redirecting your customer to
another page or application. */
    redirect_to_url?: PaymentIntentNextActionRedirectToUrl | undefined;
    /** Type of the next action to perform, one of redirect_to_url or
use_stripe_sdk. */
    type?: string | undefined;
}

export interface StripeEntityOfPaymentIntentNextActionRedirectToUrl extends StripeEntity {
}

export interface PaymentIntentNextActionRedirectToUrl extends StripeEntityOfPaymentIntentNextActionRedirectToUrl {
    /** If the customer does not exit their browser while authenticating, they will be
redirected to this specified URL after completion. */
    return_url?: string | undefined;
    /** The URL you must redirect your customer to in order to authenticate the payment. */
    url?: string | undefined;
}

export interface StripeEntityOfPaymentIntentPaymentMethodOptions extends StripeEntity {
}

export interface PaymentIntentPaymentMethodOptions extends StripeEntityOfPaymentIntentPaymentMethodOptions {
    /** If the PaymentIntent’s supported payment method types include card, this hash
contains the configurations that will be applied to each payment attempt of that type. */
    card?: PaymentIntentPaymentMethodOptionsCard | undefined;
}

export interface StripeEntityOfPaymentIntentPaymentMethodOptionsCard extends StripeEntity {
}

export interface PaymentIntentPaymentMethodOptionsCard extends StripeEntityOfPaymentIntentPaymentMethodOptionsCard {
    /** We strongly recommend that you rely on our SCA engine to automatically prompt your
customers for authentication based on risk level and other requirements. However, if
you wish to request authentication based on logic from your own fraud engine, provide
this option. Permitted values include: automatic, any, or
challenge_only. */
    request_three_d_secure?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfReview {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Review | undefined;
}

export interface StripeEntityOfReview extends StripeEntity {
}

export interface Review extends StripeEntityOfReview {
    id?: string | undefined;
    object?: string | undefined;
    charge?: ExpandableFieldOfCharge | undefined;
    created: string;
    livemode: boolean;
    open: boolean;
    payment_intent?: ExpandableFieldOfPaymentIntent | undefined;
    reason?: string | undefined;
}

export interface StripeEntityOfPaymentIntentTransferData extends StripeEntity {
}

export interface PaymentIntentTransferData extends StripeEntityOfPaymentIntentTransferData {
    /** The amount transferred to the destination account, if specified. By default, the entire
charge amount is transferred to the destination account. */
    amount?: number | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
}

export interface ChargePaymentMethodDetails extends StripeEntity {
    ach_credit_transfer?: ChargePaymentMethodDetailsAchCreditTransfer | undefined;
    ach_debit?: ChargePaymentMethodDetailsAchDebit | undefined;
    acss_debit?: ChargePaymentMethodDetailsAchDebit | undefined;
    alipay?: ChargePaymentMethodDetailsAlipay | undefined;
    bancontact?: ChargePaymentMethodDetailsBancontact | undefined;
    bitcoin?: ChargePaymentMethodDetailsBitcoin | undefined;
    card?: ChargePaymentMethodDetailsCard | undefined;
    card_present?: ChargePaymentMethodDetailsCardPresent | undefined;
    eps?: ChargePaymentMethodDetailsEps | undefined;
    giropay?: ChargePaymentMethodDetailsGiropay | undefined;
    ideal?: ChargePaymentMethodDetailsIdeal | undefined;
    klarna?: ChargePaymentMethodDetailsKlarna | undefined;
    multibanco?: ChargePaymentMethodDetailsMultibanco | undefined;
    p24?: ChargePaymentMethodDetailsP24 | undefined;
    sepa_debit?: ChargePaymentMethodDetailsSepaDebit | undefined;
    stripe_account?: ChargePaymentMethodDetailsStripeAccount | undefined;
    type?: string | undefined;
    wechat?: ChargePaymentMethodDetailsWechat | undefined;
}

export interface ChargePaymentMethodDetailsAchCreditTransfer extends StripeEntity {
    account_number?: string | undefined;
    bank_name?: string | undefined;
    routing_number?: string | undefined;
    swift_code?: string | undefined;
}

export interface ChargePaymentMethodDetailsAchDebit extends StripeEntity {
    account_holder_type?: string | undefined;
    bank_name?: string | undefined;
    country?: string | undefined;
    fingerprint?: string | undefined;
    last4?: string | undefined;
    routing_number?: string | undefined;
}

export interface ChargePaymentMethodDetailsAlipay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsBancontact extends StripeEntity {
    bank_code?: string | undefined;
    bank_name?: string | undefined;
    bic?: string | undefined;
    iban_last4?: string | undefined;
    preferred_language?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsBitcoin extends StripeEntity {
    address?: string | undefined;
    amount: number;
    amount_charged: number;
    amount_received: number;
    amount_returned: number;
    refund_address?: string | undefined;
}

export interface ChargePaymentMethodDetailsCard extends StripeEntity {
    /** Card brand. Can be amex, diners, discover, jcb,
mastercard, unionpay, visa, or unknown. */
    brand?: string | undefined;
    /** Check results by Card networks on Card address and CVC at time of payment. */
    checks?: ChargePaymentMethodDetailsCardChecks | undefined;
    /** Two-letter ISO code representing the country of the card. You could use this attribute
to get a sense of the international breakdown of cards you’ve collected. */
    country?: string | undefined;
    /** Two-digit number representing the card’s expiration month. */
    exp_month: number;
    /** Four-digit number representing the card’s expiration year. */
    exp_year: number;
    /** Uniquely identifies this particular card number. You can use this attribute to check
whether two customers who’ve signed up with you are using the same card number, for
example. */
    fingerprint?: string | undefined;
    /** Card funding type. Can be credit, debit, prepaid, or
unknown. */
    funding?: string | undefined;
    /** The last four digits of the card. */
    last4?: string | undefined;
    /** True if this payment was marked as MOTO and out of scope for SCA. */
    moto?: boolean | undefined;
    /** Populated if this transaction used 3D Secure authentication. */
    three_d_secure?: ChargePaymentMethodDetailsCardThreeDSecure | undefined;
    /** If this Card is part of a card wallet, this contains the details of the card wallet. */
    wallet?: ChargePaymentMethodDetailsCardWallet | undefined;
}

export interface ChargePaymentMethodDetailsCardChecks extends StripeEntity {
    address_line1_check?: string | undefined;
    address_postal_code_check?: string | undefined;
    cvc_check?: string | undefined;
}

export interface ChargePaymentMethodDetailsCardThreeDSecure extends StripeEntity {
    /** Whether or not authentication was performed. 3D Secure will succeed without
authentication when the card is not enrolled. */
    authenticated: boolean;
    /** Whether or not 3D Secure succeeded. */
    succeeded: boolean;
    /** The version of 3D Secure that was used for this payment. */
    version?: string | undefined;
}

export interface ChargePaymentMethodDetailsCardWallet extends StripeEntity {
    amex_express_checkout?: ChargePaymentMethodDetailsCardWalletAmexExpressCheckout | undefined;
    apple_pay?: ChargePaymentMethodDetailsCardWalletApplePay | undefined;
    dynamic_last4?: string | undefined;
    google_pay?: ChargePaymentMethodDetailsCardWalletGooglePay | undefined;
    masterpass?: ChargePaymentMethodDetailsCardWalletMasterpass | undefined;
    samsung_pay?: ChargePaymentMethodDetailsCardWalletSamsungPay | undefined;
    type?: string | undefined;
    visa_checkout?: ChargePaymentMethodDetailsCardWalletVisaCheckout | undefined;
}

export interface ChargePaymentMethodDetailsCardWalletAmexExpressCheckout extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletApplePay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletGooglePay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletMasterpass extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface ChargePaymentMethodDetailsCardWalletSamsungPay extends StripeEntity {
}

export interface ChargePaymentMethodDetailsCardWalletVisaCheckout extends StripeEntity {
    billing_address?: Address2 | undefined;
    email?: string | undefined;
    name?: string | undefined;
    shipping_address?: Address2 | undefined;
}

export interface ChargePaymentMethodDetailsCardPresent extends StripeEntity {
    brand?: string | undefined;
    country?: string | undefined;
    emv_auth_data?: string | undefined;
    exp_month: number;
    exp_year: number;
    fingerprint?: string | undefined;
    funding?: string | undefined;
    generated_card?: string | undefined;
    last4?: string | undefined;
    read_method?: string | undefined;
    receipt?: ChargePaymentMethodDetailsCardPresentReceipt | undefined;
}

export interface ChargePaymentMethodDetailsCardPresentReceipt extends StripeEntity {
    application_cryptogram?: string | undefined;
    application_preferred_name?: string | undefined;
    authorization_code?: string | undefined;
    authorization_response_code?: string | undefined;
    cardholder_verification_method?: string | undefined;
    dedicated_file_name?: string | undefined;
    terminal_verification_results?: string | undefined;
    transaction_status_information?: string | undefined;
}

export interface ChargePaymentMethodDetailsEps extends StripeEntity {
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsGiropay extends StripeEntity {
    bank_code?: string | undefined;
    bank_name?: string | undefined;
    bic?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsIdeal extends StripeEntity {
    bank?: string | undefined;
    bic?: string | undefined;
    iban_last4?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsKlarna extends StripeEntity {
}

export interface ChargePaymentMethodDetailsMultibanco extends StripeEntity {
    entity?: string | undefined;
    reference?: string | undefined;
}

export interface ChargePaymentMethodDetailsP24 extends StripeEntity {
    reference?: string | undefined;
    verified_name?: string | undefined;
}

export interface ChargePaymentMethodDetailsSepaDebit extends StripeEntity {
    bank_code?: string | undefined;
    branch_code?: string | undefined;
    country?: string | undefined;
    fingerprint?: string | undefined;
    last4?: string | undefined;
}

export interface ChargePaymentMethodDetailsStripeAccount extends StripeEntity {
}

export interface ChargePaymentMethodDetailsWechat extends StripeEntity {
}

export interface StripeEntityOfStripeListOfRefund extends StripeEntity {
}

export interface StripeListOfRefund extends StripeEntityOfStripeListOfRefund {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: Refund[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfChargeTransferData extends StripeEntity {
}

export interface ChargeTransferData extends StripeEntityOfChargeTransferData {
    amount?: number | undefined;
    destination?: ExpandableFieldOfAccount | undefined;
}

export interface StripeEntityOfInvoiceCustomField extends StripeEntity {
}

export interface InvoiceCustomField extends StripeEntityOfInvoiceCustomField {
    name?: string | undefined;
    value?: string | undefined;
}

export interface InvoiceCustomerTaxId extends StripeEntity {
    /** Type of the tax ID, one of eu_vat, nz_gst, au_abn, or
unknown. */
    type?: string | undefined;
    /** The value of the tax ID. */
    value?: string | undefined;
}

export interface StripeEntityOfStripeListOfInvoiceLineItem extends StripeEntity {
}

export interface StripeListOfInvoiceLineItem extends StripeEntityOfStripeListOfInvoiceLineItem {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: InvoiceLineItem[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfInvoiceLineItem extends StripeEntity {
}

export interface InvoiceLineItem extends StripeEntityOfInvoiceLineItem {
    id?: string | undefined;
    object?: string | undefined;
    amount: number;
    currency?: string | undefined;
    date: string;
    description?: string | undefined;
    discountable: boolean;
    invoice_item?: string | undefined;
    livemode: boolean;
    metadata?: { [key: string]: string; } | undefined;
    period?: Period | undefined;
    plan?: Plan | undefined;
    proration: boolean;
    quantity?: number | undefined;
    subscription?: string | undefined;
    subscription_item?: string | undefined;
    /** The tax amounts which apply to this line item. */
    tax_amounts?: InvoiceTaxAmount[] | undefined;
    /** Tax rates applied to this line item. */
    tax_rates?: TaxRate[] | undefined;
    type?: string | undefined;
    /** Set to true if we grouped proration items into one,
false if not. */
    unified_proration: boolean;
}

export interface StripeEntityOfPeriod extends StripeEntity {
}

export interface Period extends StripeEntityOfPeriod {
    start?: string | undefined;
    end?: string | undefined;
}

export interface InvoiceTaxAmount extends StripeEntity {
    /** The amount, in cents, of the tax. */
    amount: number;
    /** This specifies if the tax rate is inclusive or exclusive. */
    inclusive: boolean;
    tax_rate?: ExpandableFieldOfTaxRate | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfTaxRate {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: TaxRate | undefined;
}

export interface InvoiceStatusTransitions extends StripeEntity {
    finalized_at?: string | undefined;
    marked_uncollectible_at?: string | undefined;
    paid_at?: string | undefined;
    voided_at?: string | undefined;
}

export interface StripeEntityOfInvoiceThresholdReason extends StripeEntity {
}

export interface InvoiceThresholdReason extends StripeEntityOfInvoiceThresholdReason {
    /** The total invoice amount threshold boundary if it triggered the threshold invoice. */
    amount_gte?: number | undefined;
    /** Indicates which line items triggered a threshold invoice. */
    item_reasons?: InvoiceThresholdReasonItemReason[] | undefined;
}

export interface StripeEntityOfInvoiceThresholdReasonItemReason extends StripeEntity {
}

export interface InvoiceThresholdReasonItemReason extends StripeEntityOfInvoiceThresholdReasonItemReason {
    /** The IDs of the line items that triggered the threshold invoice. */
    line_item_ids?: string[] | undefined;
    /** The quantity threshold boundary that applied to the given line item. */
    usage_gte?: number | undefined;
}

export interface StripeEntityOfInvoiceTransferData extends StripeEntity {
}

export interface InvoiceTransferData extends StripeEntityOfInvoiceTransferData {
    destination?: ExpandableFieldOfAccount | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfSetupIntent {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: SetupIntent | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfSubscriptionSchedule {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: SubscriptionSchedule | undefined;
}

export interface StripeEntityOfSubscriptionSchedule extends StripeEntity {
}

export interface SubscriptionSchedule extends StripeEntityOfSubscriptionSchedule {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** This field has been renamed to CollectionMethod and will be removed
in a future API version. */
    billing?: Billing | undefined;
    /** Define thresholds at which an invoice will be sent, and the subscription advanced to a
new billing period */
    billing_thresholds?: SubscriptionBillingThresholds | undefined;
    /** Time at which the subscription schedule was canceled. Measured in seconds since the
Unix epoch. */
    canceled_at?: string | undefined;
    /** Either charge_automatically, or send_invoice. When charging
automatically, Stripe will attempt to pay this subscription at the
end of the cycle using the default source attached to the customer.
When sending an invoice, Stripe will email your customer an invoice
with payment instructions. */
    collection_method?: string | undefined;
    /** Time at which the subscription schedule was completed. Measured in seconds since the
Unix epoch. */
    completed_at?: string | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created?: string | undefined;
    /** Object representing the start and end dates for the current phase of the subscription
schedule, if it is active. */
    current_phase?: SubscriptionScheduleCurrentPhase | undefined;
    customer?: ExpandableFieldOfCustomer | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    default_source?: ExpandableFieldOfIPaymentSource | undefined;
    /** Behavior of the subscription schedule and underlying subscription when it ends. Possible
values are cancel, none, release and renew. */
    end_behavior?: string | undefined;
    /** The schedule's default invoice settings. */
    invoice_settings?: SubscriptionScheduleInvoiceSettings | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** A set of key/value pairs that you can attach to a subscription schedule object. */
    metadata?: { [key: string]: string; } | undefined;
    /** Configuration for the subscription schedule’s phases. */
    phases?: SubscriptionSchedulePhase[] | undefined;
    /** Time at which the subscription schedule was released. Measured in seconds since the
Unix epoch. */
    released_at?: string | undefined;
    /** ID of the subscription once managed by the subscription schedule (if it is released). */
    released_subscription?: string | undefined;
    /** Behavior of the subscription schedule and underlying subscription when it ends. */
    renewal_behavior?: string | undefined;
    /** Interval and duration at which the subscription schedule renews for when it ends if
renewal_behavior is renew. */
    renewal_interval?: SubscriptionScheduleRenewalInterval | undefined;
    /** Possible values are active, canceled, completed,
not_started, released and renewal_behavior. */
    status?: string | undefined;
    subscription?: ExpandableFieldOfSubscription | undefined;
}

export interface StripeEntityOfSubscriptionScheduleCurrentPhase extends StripeEntity {
}

export interface SubscriptionScheduleCurrentPhase extends StripeEntityOfSubscriptionScheduleCurrentPhase {
    /** The end of the this phase of the subscription schedule. */
    end_date?: string | undefined;
    /** The start of this phase of the subscription schedule. */
    start_date?: string | undefined;
}

export interface StripeEntityOfSubscriptionScheduleInvoiceSettings extends StripeEntity {
}

export interface SubscriptionScheduleInvoiceSettings extends StripeEntityOfSubscriptionScheduleInvoiceSettings {
    /** The number of days from which the invoice is created until it is due. */
    days_until_due?: number | undefined;
}

export interface StripeEntityOfSubscriptionSchedulePhase extends StripeEntity {
}

export interface SubscriptionSchedulePhase extends StripeEntityOfSubscriptionSchedulePhase {
    /** A non-negative decimal between 0 and 100, with at most two decimal places. This
represents the percentage of the subscription invoice subtotal that will be transferred
to the application owner’s Stripe account during this phase of the schedule. */
    application_fee_percent?: number | undefined;
    /** Define thresholds at which an invoice will be sent, and the subscription advanced to a
new billing period */
    billing_thresholds?: SubscriptionBillingThresholds | undefined;
    /** Either charge_automatically, or send_invoice. When charging
automatically, Stripe will attempt to pay this subscription at the
end of the cycle using the default source attached to the customer.
When sending an invoice, Stripe will email your customer an invoice
with payment instructions. */
    collection_method?: string | undefined;
    coupon?: ExpandableFieldOfCoupon | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    /** The default tax rates which apply to the phase of this subscription schedule. */
    default_tax_rates?: TaxRate[] | undefined;
    /** The end of this phase of the subscription schedule. */
    end_date?: string | undefined;
    /** The default invoice settings for this phase. */
    invoice_settings?: SubscriptionScheduleInvoiceSettings | undefined;
    /** Plans to subscribe during this phase of the subscription schedule. */
    plans?: SubscriptionSchedulePhaseItem[] | undefined;
    /** The start of this phase of the subscription schedule. */
    start_date?: string | undefined;
    /** If provided, each invoice created during this phase of the subscription schedule will
apply the tax rate, increasing the amount billed to the customer. */
    tax_percent?: number | undefined;
    /** When the trial ends within the phase. */
    trial_end?: string | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfCoupon {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Coupon | undefined;
}

export interface StripeEntityOfSubscriptionSchedulePhaseItem extends StripeEntity {
}

export interface SubscriptionSchedulePhaseItem extends StripeEntityOfSubscriptionSchedulePhaseItem {
    /** Define thresholds at which an invoice will be sent, and the subscription advanced to a
new billing period. */
    billing_thresholds?: SubscriptionItemBillingThresholds | undefined;
    plan?: ExpandableFieldOfPlan | undefined;
    /** Quantity of the plan to which the customer should be subscribed. */
    quantity: number;
    /** The tax rates which apply to this specific item on the phase for a subscription
schedule. */
    tax_rates?: TaxRate[] | undefined;
}

export interface StripeEntityOfSubscriptionItemBillingThresholds extends StripeEntity {
}

export interface SubscriptionItemBillingThresholds extends StripeEntityOfSubscriptionItemBillingThresholds {
    /** Usage threshold that triggers the subscription to create an invoice. */
    usage_gte?: number | undefined;
}

/** Represents a generic expandable field. */
export interface ExpandableFieldOfPlan {
    /** Gets or sets the ID. */
    id?: string | undefined;
    /** Gets or sets the expanded object. */
    expandedObject?: Plan | undefined;
}

export interface StripeEntityOfSubscriptionScheduleRenewalInterval extends StripeEntity {
}

export interface SubscriptionScheduleRenewalInterval extends StripeEntityOfSubscriptionScheduleRenewalInterval {
    /** Interval at which to renew the subscription schedule for when it ends. */
    interval?: string | undefined;
    /** Number of intervals to renew the subscription schedule for when it ends. */
    length: number;
}

export interface StripeEntityOfSubscriptionTransferData extends StripeEntity {
}

export interface SubscriptionTransferData extends StripeEntityOfSubscriptionTransferData {
    destination?: ExpandableFieldOfAccount | undefined;
}

export interface StripeEntityOfCustomerInvoiceSettings extends StripeEntity {
}

export interface CustomerInvoiceSettings extends StripeEntityOfCustomerInvoiceSettings {
    /** Default custom fields to be displayed on invoices for this customer. */
    custom_fields?: InvoiceCustomField[] | undefined;
    default_payment_method?: ExpandableFieldOfPaymentMethod | undefined;
    /** Default footer to be displayed on invoices for this customer. */
    footer?: string | undefined;
}

export interface StripeEntityOfStripeListOfIPaymentSource extends StripeEntity {
}

export interface StripeListOfIPaymentSource extends StripeEntityOfStripeListOfIPaymentSource {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: IPaymentSource[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfSubscription extends StripeEntity {
}

export interface StripeListOfSubscription extends StripeEntityOfStripeListOfSubscription {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: Subscription[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface StripeEntityOfStripeListOfTaxId extends StripeEntity {
}

export interface StripeListOfTaxId extends StripeEntityOfStripeListOfTaxId {
    /** A string describing the object type returned. */
    object?: string | undefined;
    /** A list containing the actual response elements, paginated by any request parameters. */
    data?: TaxId[] | undefined;
    /** Whether or not there are more elements available after this set. If false,
this set comprises the end of the list. */
    has_more: boolean;
    /** The URL for accessing this list. */
    url?: string | undefined;
}

export interface TaxId extends StripeEntity {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** String representing the object’s type. Objects of the same type share the same value. */
    object?: string | undefined;
    /** Two-letter ISO code representing the country of the tax ID. */
    country?: string | undefined;
    /** Time at which the object was created. Measured in seconds since the Unix epoch. */
    created: string;
    customer?: ExpandableFieldOfCustomer | undefined;
    /** Whether this object is deleted or not. */
    deleted?: boolean | undefined;
    /** Has the value true if the object exists in live mode or the value
false if the object exists in test mode. */
    livemode: boolean;
    /** Type of the tax ID, one of au_abn, eu_vat, in_gst, no_vat,
nz_gst, or unknown */
    type?: string | undefined;
    /** Value of the tax ID. */
    value?: string | undefined;
    /** The persons’s verification status. */
    verification?: TaxIdVerification | undefined;
}

export interface TaxIdVerification extends StripeEntity {
    /** Verification status, one of pending, unavailable, unverified, or
verified. */
    status?: string | undefined;
    /** The official address associated with the tax ID returned from the external provider. */
    verified_address?: string | undefined;
    /** The official name associated with the tax ID returned from the external provider. */
    verified_name?: string | undefined;
}

export interface StripeEntityOfCustomerTaxInfo extends StripeEntity {
}

export interface CustomerTaxInfo extends StripeEntityOfCustomerTaxInfo {
    tax_id?: string | undefined;
    type?: string | undefined;
}

export interface StripeEntityOfCustomerTaxInfoVerification extends StripeEntity {
}

export interface CustomerTaxInfoVerification extends StripeEntityOfCustomerTaxInfoVerification {
    status?: string | undefined;
    verified_name?: string | undefined;
}

export interface SessionDisplayItem extends StripeEntity {
    /** Amount for the display item. */
    amount?: number | undefined;
    /** Three-letter ISO currency code, in lowercase. Must be a supported currency. */
    currency?: string | undefined;
    /** Details about the display item if it's of type custom. */
    custom?: SessionDisplayItemCustom | undefined;
    /** The Plan if the display item is of type plan. */
    plan?: Plan | undefined;
    /** Quantity of the display item being purchased. */
    quantity?: number | undefined;
    /** The Sku if the display item is of type sku. */
    sku?: Sku | undefined;
    /** The type of display item. */
    type?: string | undefined;
}

export interface SessionDisplayItemCustom extends StripeEntity {
    /** The description of the line item. */
    description?: string | undefined;
    /** The images of the line item. */
    images?: string[] | undefined;
    /** The name of the line item. */
    name?: string | undefined;
}

export interface RewardBoxViewModel {
    customerId: string;
    boxId: string;
    orderHeaderId?: string | undefined;
    proceedToStripe: boolean;
}

export interface SubscriptionSignupViewModel {
    customerId: string;
    packId: string;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
}

export interface ExternalAppConfig {
    id: string;
    headerText?: string | undefined;
    headerTextEnabled: boolean;
    specialsText?: string | undefined;
    specialsTextEnabled: boolean;
    footerText?: string | undefined;
    footerTextEnabled: boolean;
    tandCsText?: string | undefined;
    tandCsTextEnabled: boolean;
}

export interface FrontendConfig {
    theme: { [key: string]: any; };
    logo: string;
    products: boolean;
    subscriptions: boolean;
    specials: boolean;
    canShip: boolean;
    latitude: number;
    longitude: number;
    title: string;
    address1: string;
    address3: string;
    postcode: string;
    ageGateImage?: string | undefined;
    headerBackground: string;
    instagram?: InstagramConfig | undefined;
    stripeKey: string;
}

export interface InstagramConfig {
    id: string;
    user: string;
}

export interface OrderHistoryDTO {
    orderNumber?: string | undefined;
    orderNum: number;
    orderId: string;
    orderDate?: string | undefined;
    total: number;
    shipped: boolean;
    invoiced: boolean;
    invoiceId?: string | undefined;
    orderLines?: OrderHistoryLine[] | undefined;
}

export interface OrderHistoryLine {
    orderLineId: string;
    product?: Product | undefined;
    quantity: number;
}

export interface ProductDTO {
    productID: string;
    name?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    sellPrice: number;
    imageId?: string | undefined;
    active: boolean;
    showRemainingUnits: boolean;
    remainingUnits: number;
    applyMaxPurchaseUnits: boolean;
    maxPurchaseUnits: number;
    dataFields?: CustomDataField[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}